// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./colors-light.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/fonts/AvenirNext.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit {
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active)  {

  [type='checkbox']:checked {
    appearance: auto;
  }
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active)  {

  [type='radio']:checked {
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active)  {

  [type='checkbox']:indeterminate {
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.form-checkbox,.form-radio {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}
.form-checkbox {
  border-radius: 0px;
}
.form-radio {
  border-radius: 100%;
}
.form-checkbox:focus,.form-radio:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.form-checkbox:checked,.form-radio:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.form-checkbox:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@media (forced-colors: active)  {

  .form-checkbox:checked {
    appearance: auto;
  }
}
.form-radio:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@media (forced-colors: active)  {

  .form-radio:checked {
    appearance: auto;
  }
}
.form-checkbox:checked:hover,.form-checkbox:checked:focus,.form-radio:checked:hover,.form-radio:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}
.form-checkbox:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
@media (forced-colors: active)  {

  .form-checkbox:indeterminate {
    appearance: auto;
  }
}
.form-checkbox:indeterminate:hover,.form-checkbox:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}
.prose {
  color: var(--tw-prose-body);
  max-width: 65ch;
}
.prose :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose :where(a):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}
.prose :where(strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-bold);
  font-weight: 600;
}
.prose :where(a strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-left: 1.625em;
}
.prose :where(ol[type="A"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="A" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="I"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="I" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="1"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
}
.prose :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: disc;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-left: 1.625em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  font-weight: 400;
  color: var(--tw-prose-counters);
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  color: var(--tw-prose-bullets);
}
.prose :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.25em;
}
.prose :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-left-width: 0.25rem;
  border-left-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}
.prose :where(blockquote p:first-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: open-quote;
}
.prose :where(blockquote p:last-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: close-quote;
}
.prose :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose :where(h1 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 900;
  color: inherit;
}
.prose :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose :where(h2 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 800;
  color: inherit;
}
.prose :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose :where(h3 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose :where(h4 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  display: block;
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-family: inherit;
  color: var(--tw-prose-kbd);
  box-shadow: 0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%), 0 3px 0 rgb(var(--tw-prose-kbd-shadows) / 10%);
  font-size: 0.875em;
  border-radius: 0.3125rem;
  padding-top: 0.1875em;
  padding-right: 0.375em;
  padding-bottom: 0.1875em;
  padding-left: 0.375em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: "\`";
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: "\`";
}
.prose :where(a code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h1 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.875em;
}
.prose :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.9em;
}
.prose :where(h4 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: none;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: none;
}
.prose :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose :where(thead):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}
.prose :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}
.prose :where(tbody tr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}
.prose :where(tbody tr:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 0;
}
.prose :where(tbody td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: baseline;
}
.prose :where(tfoot):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-top-width: 1px;
  border-top-color: var(--tw-prose-th-borders);
}
.prose :where(tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: top;
}
.prose :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose {
  --tw-prose-body: var(--color-text);
  --tw-prose-headings: var(--color-text-strong);
  --tw-prose-lead: var(--color-text-strong);
  --tw-prose-links: var(--color-info);
  --tw-prose-bold: var(--color-text-strong);
  --tw-prose-counters: var(--color-neutral);
  --tw-prose-bullets: var(--color-neutral);
  --tw-prose-hr: var(--color-border);
  --tw-prose-quotes: var(--color-neutral);
  --tw-prose-quote-borders: var(--color-neutral-dark);
  --tw-prose-captions: var(--color-text-subtle);
  --tw-prose-kbd: #111827;
  --tw-prose-kbd-shadows: 17 24 39;
  --tw-prose-code: var(--color-main);
  --tw-prose-pre-code: var(--color-main-faded);
  --tw-prose-pre-bg: var(--color-surface-subtle);
  --tw-prose-th-borders: var(--color-border);
  --tw-prose-td-borders: var(--color-border);
  --tw-prose-invert-body: #d1d5db;
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: #9ca3af;
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: #9ca3af;
  --tw-prose-invert-bullets: #4b5563;
  --tw-prose-invert-hr: #374151;
  --tw-prose-invert-quotes: #f3f4f6;
  --tw-prose-invert-quote-borders: #374151;
  --tw-prose-invert-captions: #9ca3af;
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: 255 255 255;
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: #d1d5db;
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: #4b5563;
  --tw-prose-invert-td-borders: #374151;
  font-size: 1rem;
  line-height: 1.75;
}
.prose :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-left: 0.375em;
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-left: 0.375em;
}
.prose :where(.prose > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(.prose > ul > li > *:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ul > li > *:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(.prose > ol > li > *:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ol > li > *:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  padding-left: 1.625em;
}
.prose :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-left: 0;
}
.prose :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-right: 0;
}
.prose :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}
.prose :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-left: 0;
}
.prose :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-right: 0;
}
.prose :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(.prose > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(.prose > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-top-base {
  top: calc(var(--spacing-base) * -1);
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-full {
  top: 100%;
}
.z-30 {
  z-index: 30;
}
.z-backdrop {
  z-index: var(--z-backdrop);
}
.z-dropdown {
  z-index: var(--z-dropdown);
}
.z-fixed {
  z-index: var(--z-fixed);
}
.z-modal {
  z-index: var(--z-modal);
}
.z-modal-backdrop {
  z-index: var(--z-modal-backdrop);
}
.z-offcanvas {
  z-index: var(--z-offcanvas);
}
.z-popover {
  z-index: var(--z-popover);
}
.z-sticky {
  z-index: var(--z-sticky);
}
.z-tooltip {
  z-index: var(--z-tooltip);
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-start-3 {
  grid-column-start: 3;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.m-2xs {
  margin: var(--spacing-2xs);
}
.m-\\[2px\\] {
  margin: 2px;
}
.m-auto {
  margin: auto;
}
.m-base {
  margin: var(--spacing-base);
}
.m-lg {
  margin: var(--spacing-lg);
}
.m-sm {
  margin: var(--spacing-sm);
}
.m-xl {
  margin: var(--spacing-xl);
}
.m-xs {
  margin: var(--spacing-xs);
}
.m-xxl {
  margin: var(--spacing-xxl);
}
.m-xxs {
  margin: var(--spacing-xxs);
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2xs {
  margin-left: var(--spacing-2xs);
  margin-right: var(--spacing-2xs);
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-base {
  margin-left: var(--spacing-base);
  margin-right: var(--spacing-base);
}
.mx-lg {
  margin-left: var(--spacing-lg);
  margin-right: var(--spacing-lg);
}
.mx-sm {
  margin-left: var(--spacing-sm);
  margin-right: var(--spacing-sm);
}
.mx-xl {
  margin-left: var(--spacing-xl);
  margin-right: var(--spacing-xl);
}
.mx-xs {
  margin-left: var(--spacing-xs);
  margin-right: var(--spacing-xs);
}
.mx-xxl {
  margin-left: var(--spacing-xxl);
  margin-right: var(--spacing-xxl);
}
.mx-xxs {
  margin-left: var(--spacing-xxs);
  margin-right: var(--spacing-xxs);
}
.my-2xs {
  margin-top: var(--spacing-2xs);
  margin-bottom: var(--spacing-2xs);
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.my-base {
  margin-top: var(--spacing-base);
  margin-bottom: var(--spacing-base);
}
.my-lg {
  margin-top: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
}
.my-sm {
  margin-top: var(--spacing-sm);
  margin-bottom: var(--spacing-sm);
}
.my-xl {
  margin-top: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
}
.my-xs {
  margin-top: var(--spacing-xs);
  margin-bottom: var(--spacing-xs);
}
.my-xxl {
  margin-top: var(--spacing-xxl);
  margin-bottom: var(--spacing-xxl);
}
.my-xxs {
  margin-top: var(--spacing-xxs);
  margin-bottom: var(--spacing-xxs);
}
.-mr-1 {
  margin-right: -0.25rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2xs {
  margin-bottom: var(--spacing-2xs);
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-9 {
  margin-bottom: 2.25rem;
}
.mb-base {
  margin-bottom: var(--spacing-base);
}
.mb-lg {
  margin-bottom: var(--spacing-lg);
}
.mb-sm {
  margin-bottom: var(--spacing-sm);
}
.mb-xl {
  margin-bottom: var(--spacing-xl);
}
.mb-xs {
  margin-bottom: var(--spacing-xs);
}
.mb-xxl {
  margin-bottom: var(--spacing-xxl);
}
.mb-xxs {
  margin-bottom: var(--spacing-xxs);
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-24 {
  margin-left: 6rem;
}
.ml-2xs {
  margin-left: var(--spacing-2xs);
}
.ml-auto {
  margin-left: auto;
}
.ml-base {
  margin-left: var(--spacing-base);
}
.ml-lg {
  margin-left: var(--spacing-lg);
}
.ml-sm {
  margin-left: var(--spacing-sm);
}
.ml-xl {
  margin-left: var(--spacing-xl);
}
.ml-xs {
  margin-left: var(--spacing-xs);
}
.ml-xxl {
  margin-left: var(--spacing-xxl);
}
.ml-xxs {
  margin-left: var(--spacing-xxs);
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2xs {
  margin-right: var(--spacing-2xs);
}
.mr-48 {
  margin-right: 12rem;
}
.mr-auto {
  margin-right: auto;
}
.mr-base {
  margin-right: var(--spacing-base);
}
.mr-lg {
  margin-right: var(--spacing-lg);
}
.mr-sm {
  margin-right: var(--spacing-sm);
}
.mr-xl {
  margin-right: var(--spacing-xl);
}
.mr-xs {
  margin-right: var(--spacing-xs);
}
.mr-xxl {
  margin-right: var(--spacing-xxl);
}
.mr-xxs {
  margin-right: var(--spacing-xxs);
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2xs {
  margin-top: var(--spacing-2xs);
}
.mt-base {
  margin-top: var(--spacing-base);
}
.mt-lg {
  margin-top: var(--spacing-lg);
}
.mt-sm {
  margin-top: var(--spacing-sm);
}
.mt-xl {
  margin-top: var(--spacing-xl);
}
.mt-xs {
  margin-top: var(--spacing-xs);
}
.mt-xxl {
  margin-top: var(--spacing-xxl);
}
.mt-xxs {
  margin-top: var(--spacing-xxs);
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.h-xxl {
  height: var(--spacing-xxl);
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-full {
  max-height: 100%;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1\\/12 {
  width: 8.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\/12 {
  width: 16.666667%;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\/12 {
  width: 25%;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-4\\/12 {
  width: 33.333333%;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/12 {
  width: 41.666667%;
}
.w-6 {
  width: 1.5rem;
}
.w-6\\/12 {
  width: 50%;
}
.w-7 {
  width: 1.75rem;
}
.w-7\\/12 {
  width: 58.333333%;
}
.w-8 {
  width: 2rem;
}
.w-8\\/12 {
  width: 66.666667%;
}
.w-80 {
  width: 20rem;
}
.w-9\\/12 {
  width: 75%;
}
.w-auto {
  width: auto;
}
.w-base {
  width: var(--spacing-base);
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-min {
  width: min-content;
}
.w-screen {
  width: 100vw;
}
.w-xl {
  width: var(--spacing-xl);
}
.w-xxl {
  width: var(--spacing-xxl);
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[9rem\\] {
  max-width: 9rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: max-content;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-lg {
  max-width: 1024px;
}
.max-w-screen-md {
  max-width: 768px;
}
.max-w-screen-sm {
  max-width: 640px;
}
.max-w-screen-xl {
  max-width: 1280px;
}
.max-w-screen-xxl {
  max-width: 1536px;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.basis-0 {
  flex-basis: 0px;
}
.table-auto {
  table-layout: auto;
}
.-translate-x-1 {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  user-select: none;
}
.resize {
  resize: both;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-0 {
  gap: 0px;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2xl {
  gap: var(--spacing-2xl);
}
.gap-2xs {
  gap: var(--spacing-2xs);
}
.gap-base {
  gap: var(--spacing-base);
}
.gap-lg {
  gap: var(--spacing-lg);
}
.gap-px {
  gap: 1px;
}
.gap-sm {
  gap: var(--spacing-sm);
}
.gap-xl {
  gap: var(--spacing-xl);
}
.gap-xs {
  gap: var(--spacing-xs);
}
.gap-xxl {
  gap: var(--spacing-xxl);
}
.gap-xxs {
  gap: var(--spacing-xxs);
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.-space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2xl > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-2xl) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2xs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-base > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-lg > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-sm > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-sm) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-sm) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-xl > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-xs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-xxl > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-xxl) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-xxs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(var(--spacing-xxs) * var(--tw-space-x-reverse));
  margin-left: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2xs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-base > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
}
.space-y-lg > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
}
.space-y-sm > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-sm) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-sm) * var(--tw-space-y-reverse));
}
.space-y-xl > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
}
.space-y-xs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
}
.space-y-xxl > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-xxl) * var(--tw-space-y-reverse));
}
.space-y-xxs > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(var(--spacing-xxs) * var(--tw-space-y-reverse));
}
.space-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(var(--border-base) * var(--tw-divide-x-reverse));
  border-left-width: calc(var(--border-base) * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-x-lg > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(var(--border-lg) * var(--tw-divide-x-reverse));
  border-left-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-x-md > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(var(--border-md) * var(--tw-divide-x-reverse));
  border-left-width: calc(var(--border-md) * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-x-none > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(var(--border-none) * var(--tw-divide-x-reverse));
  border-left-width: calc(var(--border-none) * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-x-xl > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(var(--border-xl) * var(--tw-divide-x-reverse));
  border-left-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(var(--border-base) * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(var(--border-base) * var(--tw-divide-y-reverse));
}
.divide-y-lg > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(var(--border-lg) * var(--tw-divide-y-reverse));
}
.divide-y-md > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(var(--border-md) * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(var(--border-md) * var(--tw-divide-y-reverse));
}
.divide-y-none > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(var(--border-none) * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(var(--border-none) * var(--tw-divide-y-reverse));
}
.divide-y-xl > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(var(--border-xl) * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--color-border);
}
.divide-current > :not([hidden]) ~ :not([hidden]) {
  border-color: currentColor;
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.divide-surface-strong > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--color-surface-strong);
}
.divide-transparent > :not([hidden]) ~ :not([hidden]) {
  border-color: transparent;
}
.self-stretch {
  align-self: stretch;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.\\!rounded {
  border-radius: var(--border-radius-base) !important;
}
.rounded {
  border-radius: var(--border-radius-base);
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--border-radius-lg);
}
.rounded-md {
  border-radius: var(--border-radius-md);
}
.rounded-none {
  border-radius: var(--border-radius-none);
}
.rounded-sm {
  border-radius: var(--border-radius-sm);
}
.rounded-xl {
  border-radius: var(--border-radius-xl);
}
.rounded-xxl {
  border-radius: var(--border-radius-xxl);
}
.rounded-b {
  border-bottom-right-radius: var(--border-radius-base);
  border-bottom-left-radius: var(--border-radius-base);
}
.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-b-full {
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-b-lg {
  border-bottom-right-radius: var(--border-radius-lg);
  border-bottom-left-radius: var(--border-radius-lg);
}
.rounded-b-md {
  border-bottom-right-radius: var(--border-radius-md);
  border-bottom-left-radius: var(--border-radius-md);
}
.rounded-b-none {
  border-bottom-right-radius: var(--border-radius-none);
  border-bottom-left-radius: var(--border-radius-none);
}
.rounded-b-sm {
  border-bottom-right-radius: var(--border-radius-sm);
  border-bottom-left-radius: var(--border-radius-sm);
}
.rounded-b-xl {
  border-bottom-right-radius: var(--border-radius-xl);
  border-bottom-left-radius: var(--border-radius-xl);
}
.rounded-b-xxl {
  border-bottom-right-radius: var(--border-radius-xxl);
  border-bottom-left-radius: var(--border-radius-xxl);
}
.rounded-l {
  border-top-left-radius: var(--border-radius-base);
  border-bottom-left-radius: var(--border-radius-base);
}
.rounded-l-3xl {
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-lg {
  border-top-left-radius: var(--border-radius-lg);
  border-bottom-left-radius: var(--border-radius-lg);
}
.rounded-l-md {
  border-top-left-radius: var(--border-radius-md);
  border-bottom-left-radius: var(--border-radius-md);
}
.rounded-l-none {
  border-top-left-radius: var(--border-radius-none);
  border-bottom-left-radius: var(--border-radius-none);
}
.rounded-l-sm {
  border-top-left-radius: var(--border-radius-sm);
  border-bottom-left-radius: var(--border-radius-sm);
}
.rounded-l-xl {
  border-top-left-radius: var(--border-radius-xl);
  border-bottom-left-radius: var(--border-radius-xl);
}
.rounded-l-xxl {
  border-top-left-radius: var(--border-radius-xxl);
  border-bottom-left-radius: var(--border-radius-xxl);
}
.rounded-r {
  border-top-right-radius: var(--border-radius-base);
  border-bottom-right-radius: var(--border-radius-base);
}
.rounded-r-3xl {
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-lg {
  border-top-right-radius: var(--border-radius-lg);
  border-bottom-right-radius: var(--border-radius-lg);
}
.rounded-r-md {
  border-top-right-radius: var(--border-radius-md);
  border-bottom-right-radius: var(--border-radius-md);
}
.rounded-r-none {
  border-top-right-radius: var(--border-radius-none);
  border-bottom-right-radius: var(--border-radius-none);
}
.rounded-r-sm {
  border-top-right-radius: var(--border-radius-sm);
  border-bottom-right-radius: var(--border-radius-sm);
}
.rounded-r-xl {
  border-top-right-radius: var(--border-radius-xl);
  border-bottom-right-radius: var(--border-radius-xl);
}
.rounded-r-xxl {
  border-top-right-radius: var(--border-radius-xxl);
  border-bottom-right-radius: var(--border-radius-xxl);
}
.rounded-t {
  border-top-left-radius: var(--border-radius-base);
  border-top-right-radius: var(--border-radius-base);
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-full {
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
}
.rounded-t-lg {
  border-top-left-radius: var(--border-radius-lg);
  border-top-right-radius: var(--border-radius-lg);
}
.rounded-t-md {
  border-top-left-radius: var(--border-radius-md);
  border-top-right-radius: var(--border-radius-md);
}
.rounded-t-none {
  border-top-left-radius: var(--border-radius-none);
  border-top-right-radius: var(--border-radius-none);
}
.rounded-t-sm {
  border-top-left-radius: var(--border-radius-sm);
  border-top-right-radius: var(--border-radius-sm);
}
.rounded-t-xl {
  border-top-left-radius: var(--border-radius-xl);
  border-top-right-radius: var(--border-radius-xl);
}
.rounded-t-xxl {
  border-top-left-radius: var(--border-radius-xxl);
  border-top-right-radius: var(--border-radius-xxl);
}
.border {
  border-width: var(--border-base);
}
.border-lg {
  border-width: var(--border-lg);
}
.border-md {
  border-width: var(--border-md);
}
.border-none {
  border-width: var(--border-none);
}
.border-xl {
  border-width: var(--border-xl);
}
.border-b {
  border-bottom-width: var(--border-base);
}
.border-b-lg {
  border-bottom-width: var(--border-lg);
}
.border-b-md {
  border-bottom-width: var(--border-md);
}
.border-b-none {
  border-bottom-width: var(--border-none);
}
.border-b-xl {
  border-bottom-width: var(--border-xl);
}
.border-l {
  border-left-width: var(--border-base);
}
.border-l-lg {
  border-left-width: var(--border-lg);
}
.border-l-md {
  border-left-width: var(--border-md);
}
.border-l-none {
  border-left-width: var(--border-none);
}
.border-l-xl {
  border-left-width: var(--border-xl);
}
.border-r {
  border-right-width: var(--border-base);
}
.border-r-lg {
  border-right-width: var(--border-lg);
}
.border-r-md {
  border-right-width: var(--border-md);
}
.border-r-none {
  border-right-width: var(--border-none);
}
.border-r-xl {
  border-right-width: var(--border-xl);
}
.border-t {
  border-top-width: var(--border-base);
}
.border-t-lg {
  border-top-width: var(--border-lg);
}
.border-t-md {
  border-top-width: var(--border-md);
}
.border-t-none {
  border-top-width: var(--border-none);
}
.border-t-xl {
  border-top-width: var(--border-xl);
}
.border-none {
  border-style: none;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-border {
  border-color: var(--color-border);
}
.border-caution {
  border-color: var(--color-caution);
}
.border-critical {
  border-color: var(--color-critical);
}
.border-current {
  border-color: currentColor;
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-info {
  border-color: var(--color-info);
}
.border-main {
  border-color: var(--color-main);
}
.border-neutral {
  border-color: var(--color-neutral);
}
.border-positive {
  border-color: var(--color-positive);
}
.border-transparent {
  border-color: transparent;
}
.bg-background {
  background-color: var(--color-background);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-border {
  background-color: var(--color-border);
}
.bg-caution {
  background-color: var(--color-caution);
}
.bg-critical {
  background-color: var(--color-critical);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-info {
  background-color: var(--color-info);
}
.bg-input-background {
  background-color: var(--color-input-background);
}
.bg-main {
  background-color: var(--color-main);
}
.bg-main-dark {
  background-color: var(--color-main-dark);
}
.bg-main-faded {
  background-color: var(--color-main-faded);
}
.bg-neutral {
  background-color: var(--color-neutral);
}
.bg-positive {
  background-color: var(--color-positive);
}
.bg-surface {
  background-color: var(--color-surface);
}
.bg-surface-strong {
  background-color: var(--color-surface-strong);
}
.bg-surface-subtle {
  background-color: var(--color-surface-subtle);
}
.bg-transparent {
  background-color: transparent;
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-background {
  --tw-gradient-from: var(--color-background) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-input-background {
  --tw-gradient-from: var(--color-input-background) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-surface {
  --tw-gradient-from: var(--color-surface) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-surface-strong {
  --tw-gradient-from: var(--color-surface-strong) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-surface-subtle {
  --tw-gradient-from: var(--color-surface-subtle) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-30\\% {
  --tw-gradient-from-position: 30%;
}
.bg-top {
  background-position: top;
}
.fill-current {
  fill: currentColor;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.object-none {
  object-fit: none;
}
.object-scale-down {
  object-fit: scale-down;
}
.object-center {
  object-position: center;
}
.p-2xs {
  padding: var(--spacing-2xs);
}
.p-4 {
  padding: 1rem;
}
.p-base {
  padding: var(--spacing-base);
}
.p-lg {
  padding: var(--spacing-lg);
}
.p-sm {
  padding: var(--spacing-sm);
}
.p-xl {
  padding: var(--spacing-xl);
}
.p-xs {
  padding: var(--spacing-xs);
}
.p-xxl {
  padding: var(--spacing-xxl);
}
.p-xxs {
  padding: var(--spacing-xxs);
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2xs {
  padding-left: var(--spacing-2xs);
  padding-right: var(--spacing-2xs);
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-base {
  padding-left: var(--spacing-base);
  padding-right: var(--spacing-base);
}
.px-lg {
  padding-left: var(--spacing-lg);
  padding-right: var(--spacing-lg);
}
.px-sm {
  padding-left: var(--spacing-sm);
  padding-right: var(--spacing-sm);
}
.px-xl {
  padding-left: var(--spacing-xl);
  padding-right: var(--spacing-xl);
}
.px-xs {
  padding-left: var(--spacing-xs);
  padding-right: var(--spacing-xs);
}
.px-xxl {
  padding-left: var(--spacing-xxl);
  padding-right: var(--spacing-xxl);
}
.px-xxs {
  padding-left: var(--spacing-xxs);
  padding-right: var(--spacing-xxs);
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-2xs {
  padding-top: var(--spacing-2xs);
  padding-bottom: var(--spacing-2xs);
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-base {
  padding-top: var(--spacing-base);
  padding-bottom: var(--spacing-base);
}
.py-lg {
  padding-top: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
}
.py-sm {
  padding-top: var(--spacing-sm);
  padding-bottom: var(--spacing-sm);
}
.py-xl {
  padding-top: var(--spacing-xl);
  padding-bottom: var(--spacing-xl);
}
.py-xs {
  padding-top: var(--spacing-xs);
  padding-bottom: var(--spacing-xs);
}
.py-xxl {
  padding-top: var(--spacing-xxl);
  padding-bottom: var(--spacing-xxl);
}
.py-xxs {
  padding-top: var(--spacing-xxs);
  padding-bottom: var(--spacing-xxs);
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-2xs {
  padding-bottom: var(--spacing-2xs);
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-base {
  padding-bottom: var(--spacing-base);
}
.pb-lg {
  padding-bottom: var(--spacing-lg);
}
.pb-sm {
  padding-bottom: var(--spacing-sm);
}
.pb-xl {
  padding-bottom: var(--spacing-xl);
}
.pb-xs {
  padding-bottom: var(--spacing-xs);
}
.pb-xxl {
  padding-bottom: var(--spacing-xxl);
}
.pb-xxs {
  padding-bottom: var(--spacing-xxs);
}
.pl-0 {
  padding-left: 0px;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2xs {
  padding-left: var(--spacing-2xs);
}
.pl-base {
  padding-left: var(--spacing-base);
}
.pl-lg {
  padding-left: var(--spacing-lg);
}
.pl-sm {
  padding-left: var(--spacing-sm);
}
.pl-xl {
  padding-left: var(--spacing-xl);
}
.pl-xs {
  padding-left: var(--spacing-xs);
}
.pl-xxl {
  padding-left: var(--spacing-xxl);
}
.pl-xxs {
  padding-left: var(--spacing-xxs);
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2xs {
  padding-right: var(--spacing-2xs);
}
.pr-base {
  padding-right: var(--spacing-base);
}
.pr-lg {
  padding-right: var(--spacing-lg);
}
.pr-sm {
  padding-right: var(--spacing-sm);
}
.pr-xl {
  padding-right: var(--spacing-xl);
}
.pr-xs {
  padding-right: var(--spacing-xs);
}
.pr-xxl {
  padding-right: var(--spacing-xxl);
}
.pr-xxs {
  padding-right: var(--spacing-xxs);
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-2xs {
  padding-top: var(--spacing-2xs);
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-base {
  padding-top: var(--spacing-base);
}
.pt-lg {
  padding-top: var(--spacing-lg);
}
.pt-sm {
  padding-top: var(--spacing-sm);
}
.pt-xl {
  padding-top: var(--spacing-xl);
}
.pt-xs {
  padding-top: var(--spacing-xs);
}
.pt-xxl {
  padding-top: var(--spacing-xxl);
}
.pt-xxs {
  padding-top: var(--spacing-xxs);
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-2xl {
  font-size: var(--size-text-2xl);
  line-height: var(--line-height-text-2xl);
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-base {
  font-size: var(--size-text);
  line-height: var(--line-height-text);
}
.text-lg {
  font-size: var(--size-text-lg);
  line-height: var(--line-height-text-lg);
}
.text-md {
  font-size: var(--size-text-md);
  line-height: var(--line-height-text-md);
}
.text-sm {
  font-size: var(--size-text-sm);
  line-height: var(--line-height-text-sm);
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-none {
  line-height: 1;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-color {
  color: var(--color-text);
}
.text-color-caution {
  color: var(--color-caution);
}
.text-color-critical {
  color: var(--color-critical);
}
.text-color-info {
  color: var(--color-info);
}
.text-color-main {
  color: var(--color-main);
}
.text-color-neutral {
  color: var(--color-neutral);
}
.text-color-neutral-faded {
  color: var(--color-neutral-faded);
}
.text-color-neutral-light {
  color: var(--color-neutral-light);
}
.text-color-positive {
  color: var(--color-positive);
}
.text-color-semantic {
  color: var(--color-text-semantic);
}
.text-color-strong {
  color: var(--color-text-strong);
}
.text-color-subtle {
  color: var(--color-text-subtle);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.decoration-info {
  text-decoration-color: var(--color-info);
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.\\!outline {
  outline-style: solid !important;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-neutral-dark {
  --tw-ring-color: var(--color-neutral-dark);
}
.ring-surface {
  --tw-ring-color: var(--color-surface);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-75 {
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[filter\\] {
  transition-property: filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

html,
body {
  padding: 0;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  background-color: white;
}

a {
  color: inherit;
  text-decoration: none;
}

* {
  box-sizing: border-box;
}

.g327 {
  border-color: #302f30;
}

@font-face {
  font-family: 'AvenirNextW10-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.Avenir {
  font-family: AvenirNextW10-Bold;
  font-display: swap;
}

.clearNav {
  backdrop-filter: saturate(180%) blur(5px) !important;
  background-color: rgba(255, 255, 255, 0.6) !important;
}

.grr {
  grid-template-columns: repeat(2, 1fr);
}

.greyC {
  filter: gray;
  -webkit-filter: grayscale(100%);
  transition: 0.4s;
}

.greyC:hover {
  filter: none;
  -webkit-filter: none;
  transition: 0.4s;
}

/* Revert Tailwind CSS reset/preflight */
.tailwind-reset-revert blockquote,
  .tailwind-reset-revert dl,
  .tailwind-reset-revert dd,
  .tailwind-reset-revert h1,
  .tailwind-reset-revert h2,
  .tailwind-reset-revert h3,
  .tailwind-reset-revert h4,
  .tailwind-reset-revert h5,
  .tailwind-reset-revert h6,
  .tailwind-reset-revert hr,
  .tailwind-reset-revert figure,
  .tailwind-reset-revert p,
  .tailwind-reset-revert pre {
    margin: revert;
  }
.tailwind-reset-revert h1,
  .tailwind-reset-revert h2,
  .tailwind-reset-revert h3,
  .tailwind-reset-revert h4,
  .tailwind-reset-revert h5,
  .tailwind-reset-revert h6 {
    font-size: revert;
    font-weight: revert;
  }
.tailwind-reset-revert ol,
  .tailwind-reset-revert ul {
    list-style: revert;
    margin: revert;
    padding: revert;
  }
.odd\\:bg-surface-subtle:nth-child(odd) {
  background-color: var(--color-surface-subtle);
}
.hover\\:cursor-grab:hover {
  cursor: grab;
}
.hover\\:cursor-grabbing:hover {
  cursor: grabbing;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:border-gray-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
.hover\\:bg-critical-faded:hover {
  background-color: var(--color-critical-faded);
}
.hover\\:bg-main-faded:hover {
  background-color: var(--color-main-faded);
}
.hover\\:bg-surface-strong:hover {
  background-color: var(--color-surface-strong);
}
.hover\\:bg-surface-subtle:hover {
  background-color: var(--color-surface-subtle);
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:brightness-125:hover {
  --tw-brightness: brightness(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.focus\\:opacity-80:focus {
  opacity: 0.8;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.active\\:bg-surface-subtle:active {
  background-color: var(--color-surface-subtle);
}
.active\\:brightness-75:active {
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.group:last-child .group-last\\:hidden {
  display: none;
}
.group:hover .group-hover\\:bg-critical-light {
  background-color: var(--color-critical-light);
}
.group:hover .group-hover\\:bg-neutral-light {
  background-color: var(--color-neutral-light);
}
.group:hover .group-hover\\:bg-positive-light {
  background-color: var(--color-positive-light);
}
.group:hover .group-hover\\:text-color-strong {
  color: var(--color-text-strong);
}
.group:focus .group-focus\\:bg-critical-light {
  background-color: var(--color-critical-light);
}
.group:focus .group-focus\\:bg-neutral-light {
  background-color: var(--color-neutral-light);
}
.group:focus .group-focus\\:bg-positive-light {
  background-color: var(--color-positive-light);
}
.group:focus .group-focus\\:text-color-strong {
  color: var(--color-text-strong);
}
.group:active .group-active\\:bg-critical-dark {
  background-color: var(--color-critical-dark);
}
.group:active .group-active\\:bg-neutral-dark {
  background-color: var(--color-neutral-dark);
}
.group:active .group-active\\:bg-positive-dark {
  background-color: var(--color-positive-dark);
}
.group:active .group-active\\:text-color-subtle {
  color: var(--color-text-subtle);
}
.prose-img\\:mx-auto :is(:where(img):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  margin-left: auto;
  margin-right: auto;
}
.prose-img\\:rounded :is(:where(img):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-radius: var(--border-radius-base);
}
@media (min-width: 640px) {

  .sm\\:m-2xs {
    margin: var(--spacing-2xs);
  }

  .sm\\:m-base {
    margin: var(--spacing-base);
  }

  .sm\\:m-lg {
    margin: var(--spacing-lg);
  }

  .sm\\:m-sm {
    margin: var(--spacing-sm);
  }

  .sm\\:m-xl {
    margin: var(--spacing-xl);
  }

  .sm\\:m-xs {
    margin: var(--spacing-xs);
  }

  .sm\\:m-xxl {
    margin: var(--spacing-xxl);
  }

  .sm\\:mx-2xs {
    margin-left: var(--spacing-2xs);
    margin-right: var(--spacing-2xs);
  }

  .sm\\:mx-base {
    margin-left: var(--spacing-base);
    margin-right: var(--spacing-base);
  }

  .sm\\:mx-lg {
    margin-left: var(--spacing-lg);
    margin-right: var(--spacing-lg);
  }

  .sm\\:mx-sm {
    margin-left: var(--spacing-sm);
    margin-right: var(--spacing-sm);
  }

  .sm\\:mx-xl {
    margin-left: var(--spacing-xl);
    margin-right: var(--spacing-xl);
  }

  .sm\\:mx-xs {
    margin-left: var(--spacing-xs);
    margin-right: var(--spacing-xs);
  }

  .sm\\:mx-xxl {
    margin-left: var(--spacing-xxl);
    margin-right: var(--spacing-xxl);
  }

  .sm\\:my-2xs {
    margin-top: var(--spacing-2xs);
    margin-bottom: var(--spacing-2xs);
  }

  .sm\\:my-base {
    margin-top: var(--spacing-base);
    margin-bottom: var(--spacing-base);
  }

  .sm\\:my-lg {
    margin-top: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  .sm\\:my-sm {
    margin-top: var(--spacing-sm);
    margin-bottom: var(--spacing-sm);
  }

  .sm\\:my-xl {
    margin-top: var(--spacing-xl);
    margin-bottom: var(--spacing-xl);
  }

  .sm\\:my-xs {
    margin-top: var(--spacing-xs);
    margin-bottom: var(--spacing-xs);
  }

  .sm\\:my-xxl {
    margin-top: var(--spacing-xxl);
    margin-bottom: var(--spacing-xxl);
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-28 {
    margin-bottom: 7rem;
  }

  .sm\\:mb-2xs {
    margin-bottom: var(--spacing-2xs);
  }

  .sm\\:mb-base {
    margin-bottom: var(--spacing-base);
  }

  .sm\\:mb-lg {
    margin-bottom: var(--spacing-lg);
  }

  .sm\\:mb-sm {
    margin-bottom: var(--spacing-sm);
  }

  .sm\\:mb-xl {
    margin-bottom: var(--spacing-xl);
  }

  .sm\\:mb-xs {
    margin-bottom: var(--spacing-xs);
  }

  .sm\\:mb-xxl {
    margin-bottom: var(--spacing-xxl);
  }

  .sm\\:ml-2xs {
    margin-left: var(--spacing-2xs);
  }

  .sm\\:ml-base {
    margin-left: var(--spacing-base);
  }

  .sm\\:ml-lg {
    margin-left: var(--spacing-lg);
  }

  .sm\\:ml-sm {
    margin-left: var(--spacing-sm);
  }

  .sm\\:ml-xl {
    margin-left: var(--spacing-xl);
  }

  .sm\\:ml-xs {
    margin-left: var(--spacing-xs);
  }

  .sm\\:ml-xxl {
    margin-left: var(--spacing-xxl);
  }

  .sm\\:mr-0 {
    margin-right: 0px;
  }

  .sm\\:mr-2xs {
    margin-right: var(--spacing-2xs);
  }

  .sm\\:mr-base {
    margin-right: var(--spacing-base);
  }

  .sm\\:mr-lg {
    margin-right: var(--spacing-lg);
  }

  .sm\\:mr-sm {
    margin-right: var(--spacing-sm);
  }

  .sm\\:mr-xl {
    margin-right: var(--spacing-xl);
  }

  .sm\\:mr-xs {
    margin-right: var(--spacing-xs);
  }

  .sm\\:mr-xxl {
    margin-right: var(--spacing-xxl);
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-2xs {
    margin-top: var(--spacing-2xs);
  }

  .sm\\:mt-base {
    margin-top: var(--spacing-base);
  }

  .sm\\:mt-lg {
    margin-top: var(--spacing-lg);
  }

  .sm\\:mt-sm {
    margin-top: var(--spacing-sm);
  }

  .sm\\:mt-xl {
    margin-top: var(--spacing-xl);
  }

  .sm\\:mt-xs {
    margin-top: var(--spacing-xs);
  }

  .sm\\:mt-xxl {
    margin-top: var(--spacing-xxl);
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:h-auto {
    height: auto;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:h-screen {
    height: 100vh;
  }

  .sm\\:w-1\\/12 {
    width: 8.333333%;
  }

  .sm\\:w-10\\/12 {
    width: 83.333333%;
  }

  .sm\\:w-11\\/12 {
    width: 91.666667%;
  }

  .sm\\:w-2\\/12 {
    width: 16.666667%;
  }

  .sm\\:w-3\\/12 {
    width: 25%;
  }

  .sm\\:w-4\\/12 {
    width: 33.333333%;
  }

  .sm\\:w-5\\/12 {
    width: 41.666667%;
  }

  .sm\\:w-6\\/12 {
    width: 50%;
  }

  .sm\\:w-7\\/12 {
    width: 58.333333%;
  }

  .sm\\:w-8\\/12 {
    width: 66.666667%;
  }

  .sm\\:w-9\\/12 {
    width: 75%;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:w-max {
    width: max-content;
  }

  .sm\\:w-min {
    width: min-content;
  }

  .sm\\:w-screen {
    width: 100vw;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:items-baseline {
    align-items: baseline;
  }

  .sm\\:items-stretch {
    align-items: stretch;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:justify-around {
    justify-content: space-around;
  }

  .sm\\:justify-evenly {
    justify-content: space-evenly;
  }

  .sm\\:space-x-2xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-sm > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-sm) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-sm) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-sm > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-sm) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-sm) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxl) * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxs) * var(--tw-space-y-reverse));
  }

  .sm\\:space-x-reverse > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 1;
  }

  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-base) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-base) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-lg) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-x-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-md) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-md) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-x-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-none) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-none) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-xl) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-base) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-base) * var(--tw-divide-y-reverse));
  }

  .sm\\:divide-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-lg) * var(--tw-divide-y-reverse));
  }

  .sm\\:divide-y-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-md) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-md) * var(--tw-divide-y-reverse));
  }

  .sm\\:divide-y-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-none) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-none) * var(--tw-divide-y-reverse));
  }

  .sm\\:divide-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-xl) * var(--tw-divide-y-reverse));
  }

  .sm\\:divide-current > :not([hidden]) ~ :not([hidden]) {
    border-color: currentColor;
  }

  .sm\\:divide-transparent > :not([hidden]) ~ :not([hidden]) {
    border-color: transparent;
  }

  .sm\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .sm\\:rounded-full {
    border-radius: 9999px;
  }

  .sm\\:rounded-lg {
    border-radius: var(--border-radius-lg);
  }

  .sm\\:rounded-md {
    border-radius: var(--border-radius-md);
  }

  .sm\\:rounded-none {
    border-radius: var(--border-radius-none);
  }

  .sm\\:rounded-sm {
    border-radius: var(--border-radius-sm);
  }

  .sm\\:rounded-xl {
    border-radius: var(--border-radius-xl);
  }

  .sm\\:rounded-xxl {
    border-radius: var(--border-radius-xxl);
  }

  .sm\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .sm\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .sm\\:rounded-b-lg {
    border-bottom-right-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .sm\\:rounded-b-md {
    border-bottom-right-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .sm\\:rounded-b-none {
    border-bottom-right-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .sm\\:rounded-b-sm {
    border-bottom-right-radius: var(--border-radius-sm);
    border-bottom-left-radius: var(--border-radius-sm);
  }

  .sm\\:rounded-b-xl {
    border-bottom-right-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .sm\\:rounded-b-xxl {
    border-bottom-right-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .sm\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .sm\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .sm\\:rounded-l-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .sm\\:rounded-l-md {
    border-top-left-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .sm\\:rounded-l-none {
    border-top-left-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .sm\\:rounded-l-sm {
    border-top-left-radius: var(--border-radius-sm);
    border-bottom-left-radius: var(--border-radius-sm);
  }

  .sm\\:rounded-l-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .sm\\:rounded-l-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .sm\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .sm\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .sm\\:rounded-r-lg {
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);
  }

  .sm\\:rounded-r-md {
    border-top-right-radius: var(--border-radius-md);
    border-bottom-right-radius: var(--border-radius-md);
  }

  .sm\\:rounded-r-none {
    border-top-right-radius: var(--border-radius-none);
    border-bottom-right-radius: var(--border-radius-none);
  }

  .sm\\:rounded-r-sm {
    border-top-right-radius: var(--border-radius-sm);
    border-bottom-right-radius: var(--border-radius-sm);
  }

  .sm\\:rounded-r-xl {
    border-top-right-radius: var(--border-radius-xl);
    border-bottom-right-radius: var(--border-radius-xl);
  }

  .sm\\:rounded-r-xxl {
    border-top-right-radius: var(--border-radius-xxl);
    border-bottom-right-radius: var(--border-radius-xxl);
  }

  .sm\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .sm\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .sm\\:rounded-t-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-top-right-radius: var(--border-radius-lg);
  }

  .sm\\:rounded-t-md {
    border-top-left-radius: var(--border-radius-md);
    border-top-right-radius: var(--border-radius-md);
  }

  .sm\\:rounded-t-none {
    border-top-left-radius: var(--border-radius-none);
    border-top-right-radius: var(--border-radius-none);
  }

  .sm\\:rounded-t-sm {
    border-top-left-radius: var(--border-radius-sm);
    border-top-right-radius: var(--border-radius-sm);
  }

  .sm\\:rounded-t-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-top-right-radius: var(--border-radius-xl);
  }

  .sm\\:rounded-t-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-top-right-radius: var(--border-radius-xxl);
  }

  .sm\\:border {
    border-width: var(--border-base);
  }

  .sm\\:border-lg {
    border-width: var(--border-lg);
  }

  .sm\\:border-md {
    border-width: var(--border-md);
  }

  .sm\\:border-none {
    border-width: var(--border-none);
  }

  .sm\\:border-xl {
    border-width: var(--border-xl);
  }

  .sm\\:border-b {
    border-bottom-width: var(--border-base);
  }

  .sm\\:border-b-lg {
    border-bottom-width: var(--border-lg);
  }

  .sm\\:border-b-md {
    border-bottom-width: var(--border-md);
  }

  .sm\\:border-b-none {
    border-bottom-width: var(--border-none);
  }

  .sm\\:border-b-xl {
    border-bottom-width: var(--border-xl);
  }

  .sm\\:border-l {
    border-left-width: var(--border-base);
  }

  .sm\\:border-l-lg {
    border-left-width: var(--border-lg);
  }

  .sm\\:border-l-md {
    border-left-width: var(--border-md);
  }

  .sm\\:border-l-none {
    border-left-width: var(--border-none);
  }

  .sm\\:border-l-xl {
    border-left-width: var(--border-xl);
  }

  .sm\\:border-r {
    border-right-width: var(--border-base);
  }

  .sm\\:border-r-lg {
    border-right-width: var(--border-lg);
  }

  .sm\\:border-r-md {
    border-right-width: var(--border-md);
  }

  .sm\\:border-r-none {
    border-right-width: var(--border-none);
  }

  .sm\\:border-r-xl {
    border-right-width: var(--border-xl);
  }

  .sm\\:border-t {
    border-top-width: var(--border-base);
  }

  .sm\\:border-t-lg {
    border-top-width: var(--border-lg);
  }

  .sm\\:border-t-md {
    border-top-width: var(--border-md);
  }

  .sm\\:border-t-none {
    border-top-width: var(--border-none);
  }

  .sm\\:border-t-xl {
    border-top-width: var(--border-xl);
  }

  .sm\\:border-none {
    border-style: none;
  }

  .sm\\:border-border {
    border-color: var(--color-border);
  }

  .sm\\:border-caution {
    border-color: var(--color-caution);
  }

  .sm\\:border-critical {
    border-color: var(--color-critical);
  }

  .sm\\:border-current {
    border-color: currentColor;
  }

  .sm\\:border-info {
    border-color: var(--color-info);
  }

  .sm\\:border-main {
    border-color: var(--color-main);
  }

  .sm\\:border-neutral {
    border-color: var(--color-neutral);
  }

  .sm\\:border-positive {
    border-color: var(--color-positive);
  }

  .sm\\:border-transparent {
    border-color: transparent;
  }

  .sm\\:bg-background {
    background-color: var(--color-background);
  }

  .sm\\:bg-surface {
    background-color: var(--color-surface);
  }

  .sm\\:bg-surface-strong {
    background-color: var(--color-surface-strong);
  }

  .sm\\:bg-surface-subtle {
    background-color: var(--color-surface-subtle);
  }

  .sm\\:p-2xs {
    padding: var(--spacing-2xs);
  }

  .sm\\:p-base {
    padding: var(--spacing-base);
  }

  .sm\\:p-lg {
    padding: var(--spacing-lg);
  }

  .sm\\:p-sm {
    padding: var(--spacing-sm);
  }

  .sm\\:p-xl {
    padding: var(--spacing-xl);
  }

  .sm\\:p-xs {
    padding: var(--spacing-xs);
  }

  .sm\\:p-xxl {
    padding: var(--spacing-xxl);
  }

  .sm\\:px-2xs {
    padding-left: var(--spacing-2xs);
    padding-right: var(--spacing-2xs);
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-base {
    padding-left: var(--spacing-base);
    padding-right: var(--spacing-base);
  }

  .sm\\:px-lg {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  .sm\\:px-sm {
    padding-left: var(--spacing-sm);
    padding-right: var(--spacing-sm);
  }

  .sm\\:px-xl {
    padding-left: var(--spacing-xl);
    padding-right: var(--spacing-xl);
  }

  .sm\\:px-xs {
    padding-left: var(--spacing-xs);
    padding-right: var(--spacing-xs);
  }

  .sm\\:px-xxl {
    padding-left: var(--spacing-xxl);
    padding-right: var(--spacing-xxl);
  }

  .sm\\:py-2xs {
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .sm\\:py-base {
    padding-top: var(--spacing-base);
    padding-bottom: var(--spacing-base);
  }

  .sm\\:py-lg {
    padding-top: var(--spacing-lg);
    padding-bottom: var(--spacing-lg);
  }

  .sm\\:py-sm {
    padding-top: var(--spacing-sm);
    padding-bottom: var(--spacing-sm);
  }

  .sm\\:py-xl {
    padding-top: var(--spacing-xl);
    padding-bottom: var(--spacing-xl);
  }

  .sm\\:py-xs {
    padding-top: var(--spacing-xs);
    padding-bottom: var(--spacing-xs);
  }

  .sm\\:py-xxl {
    padding-top: var(--spacing-xxl);
    padding-bottom: var(--spacing-xxl);
  }

  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }

  .sm\\:pb-2xs {
    padding-bottom: var(--spacing-2xs);
  }

  .sm\\:pb-base {
    padding-bottom: var(--spacing-base);
  }

  .sm\\:pb-lg {
    padding-bottom: var(--spacing-lg);
  }

  .sm\\:pb-sm {
    padding-bottom: var(--spacing-sm);
  }

  .sm\\:pb-xl {
    padding-bottom: var(--spacing-xl);
  }

  .sm\\:pb-xs {
    padding-bottom: var(--spacing-xs);
  }

  .sm\\:pb-xxl {
    padding-bottom: var(--spacing-xxl);
  }

  .sm\\:pl-2xs {
    padding-left: var(--spacing-2xs);
  }

  .sm\\:pl-base {
    padding-left: var(--spacing-base);
  }

  .sm\\:pl-lg {
    padding-left: var(--spacing-lg);
  }

  .sm\\:pl-sm {
    padding-left: var(--spacing-sm);
  }

  .sm\\:pl-xl {
    padding-left: var(--spacing-xl);
  }

  .sm\\:pl-xs {
    padding-left: var(--spacing-xs);
  }

  .sm\\:pl-xxl {
    padding-left: var(--spacing-xxl);
  }

  .sm\\:pr-2xs {
    padding-right: var(--spacing-2xs);
  }

  .sm\\:pr-base {
    padding-right: var(--spacing-base);
  }

  .sm\\:pr-lg {
    padding-right: var(--spacing-lg);
  }

  .sm\\:pr-sm {
    padding-right: var(--spacing-sm);
  }

  .sm\\:pr-xl {
    padding-right: var(--spacing-xl);
  }

  .sm\\:pr-xs {
    padding-right: var(--spacing-xs);
  }

  .sm\\:pr-xxl {
    padding-right: var(--spacing-xxl);
  }

  .sm\\:pt-2xs {
    padding-top: var(--spacing-2xs);
  }

  .sm\\:pt-base {
    padding-top: var(--spacing-base);
  }

  .sm\\:pt-lg {
    padding-top: var(--spacing-lg);
  }

  .sm\\:pt-sm {
    padding-top: var(--spacing-sm);
  }

  .sm\\:pt-xl {
    padding-top: var(--spacing-xl);
  }

  .sm\\:pt-xs {
    padding-top: var(--spacing-xs);
  }

  .sm\\:pt-xxl {
    padding-top: var(--spacing-xxl);
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-base {
    font-size: var(--size-text);
    line-height: var(--line-height-text);
  }

  .sm\\:text-lg {
    font-size: var(--size-text-lg);
    line-height: var(--line-height-text-lg);
  }

  .sm\\:text-sm {
    font-size: var(--size-text-sm);
    line-height: var(--line-height-text-sm);
  }

  .sm\\:text-color {
    color: var(--color-text);
  }

  .sm\\:text-color-caution {
    color: var(--color-caution);
  }

  .sm\\:text-color-critical {
    color: var(--color-critical);
  }

  .sm\\:text-color-info {
    color: var(--color-info);
  }

  .sm\\:text-color-main {
    color: var(--color-main);
  }

  .sm\\:text-color-neutral {
    color: var(--color-neutral);
  }

  .sm\\:text-color-positive {
    color: var(--color-positive);
  }

  .sm\\:text-color-semantic {
    color: var(--color-text-semantic);
  }

  .sm\\:text-color-strong {
    color: var(--color-text-strong);
  }

  .sm\\:text-color-subtle {
    color: var(--color-text-subtle);
  }

  .group:last-child .sm\\:group-last\\:hidden {
    display: none;
  }

  .group:last-child .sm\\:group-last\\:pr-0 {
    padding-right: 0px;
  }
}
@media (min-width: 768px) {

  .md\\:-top-base {
    top: calc(var(--spacing-base) * -1);
  }

  .md\\:m-2xs {
    margin: var(--spacing-2xs);
  }

  .md\\:m-base {
    margin: var(--spacing-base);
  }

  .md\\:m-lg {
    margin: var(--spacing-lg);
  }

  .md\\:m-xl {
    margin: var(--spacing-xl);
  }

  .md\\:m-xs {
    margin: var(--spacing-xs);
  }

  .md\\:m-xxl {
    margin: var(--spacing-xxl);
  }

  .md\\:mx-2xs {
    margin-left: var(--spacing-2xs);
    margin-right: var(--spacing-2xs);
  }

  .md\\:mx-base {
    margin-left: var(--spacing-base);
    margin-right: var(--spacing-base);
  }

  .md\\:mx-lg {
    margin-left: var(--spacing-lg);
    margin-right: var(--spacing-lg);
  }

  .md\\:mx-xl {
    margin-left: var(--spacing-xl);
    margin-right: var(--spacing-xl);
  }

  .md\\:mx-xs {
    margin-left: var(--spacing-xs);
    margin-right: var(--spacing-xs);
  }

  .md\\:mx-xxl {
    margin-left: var(--spacing-xxl);
    margin-right: var(--spacing-xxl);
  }

  .md\\:my-2xs {
    margin-top: var(--spacing-2xs);
    margin-bottom: var(--spacing-2xs);
  }

  .md\\:my-base {
    margin-top: var(--spacing-base);
    margin-bottom: var(--spacing-base);
  }

  .md\\:my-lg {
    margin-top: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  .md\\:my-xl {
    margin-top: var(--spacing-xl);
    margin-bottom: var(--spacing-xl);
  }

  .md\\:my-xs {
    margin-top: var(--spacing-xs);
    margin-bottom: var(--spacing-xs);
  }

  .md\\:my-xxl {
    margin-top: var(--spacing-xxl);
    margin-bottom: var(--spacing-xxl);
  }

  .md\\:mb-2xs {
    margin-bottom: var(--spacing-2xs);
  }

  .md\\:mb-base {
    margin-bottom: var(--spacing-base);
  }

  .md\\:mb-lg {
    margin-bottom: var(--spacing-lg);
  }

  .md\\:mb-xl {
    margin-bottom: var(--spacing-xl);
  }

  .md\\:mb-xs {
    margin-bottom: var(--spacing-xs);
  }

  .md\\:mb-xxl {
    margin-bottom: var(--spacing-xxl);
  }

  .md\\:ml-1 {
    margin-left: 0.25rem;
  }

  .md\\:ml-24 {
    margin-left: 6rem;
  }

  .md\\:ml-2xs {
    margin-left: var(--spacing-2xs);
  }

  .md\\:ml-4 {
    margin-left: 1rem;
  }

  .md\\:ml-base {
    margin-left: var(--spacing-base);
  }

  .md\\:ml-lg {
    margin-left: var(--spacing-lg);
  }

  .md\\:ml-xl {
    margin-left: var(--spacing-xl);
  }

  .md\\:ml-xs {
    margin-left: var(--spacing-xs);
  }

  .md\\:ml-xxl {
    margin-left: var(--spacing-xxl);
  }

  .md\\:mr-2xs {
    margin-right: var(--spacing-2xs);
  }

  .md\\:mr-base {
    margin-right: var(--spacing-base);
  }

  .md\\:mr-lg {
    margin-right: var(--spacing-lg);
  }

  .md\\:mr-xl {
    margin-right: var(--spacing-xl);
  }

  .md\\:mr-xs {
    margin-right: var(--spacing-xs);
  }

  .md\\:mr-xxl {
    margin-right: var(--spacing-xxl);
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-2xs {
    margin-top: var(--spacing-2xs);
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mt-base {
    margin-top: var(--spacing-base);
  }

  .md\\:mt-lg {
    margin-top: var(--spacing-lg);
  }

  .md\\:mt-xl {
    margin-top: var(--spacing-xl);
  }

  .md\\:mt-xs {
    margin-top: var(--spacing-xs);
  }

  .md\\:mt-xxl {
    margin-top: var(--spacing-xxl);
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:h-screen {
    height: 100vh;
  }

  .md\\:w-1\\/12 {
    width: 8.333333%;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-10\\/12 {
    width: 83.333333%;
  }

  .md\\:w-11\\/12 {
    width: 91.666667%;
  }

  .md\\:w-2\\/12 {
    width: 16.666667%;
  }

  .md\\:w-3\\/12 {
    width: 25%;
  }

  .md\\:w-4\\/12 {
    width: 33.333333%;
  }

  .md\\:w-5\\/12 {
    width: 41.666667%;
  }

  .md\\:w-6\\/12 {
    width: 50%;
  }

  .md\\:w-7\\/12 {
    width: 58.333333%;
  }

  .md\\:w-8\\/12 {
    width: 66.666667%;
  }

  .md\\:w-9\\/12 {
    width: 75%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:w-max {
    width: max-content;
  }

  .md\\:w-min {
    width: min-content;
  }

  .md\\:w-screen {
    width: 100vw;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:items-baseline {
    align-items: baseline;
  }

  .md\\:items-stretch {
    align-items: stretch;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:justify-around {
    justify-content: space-around;
  }

  .md\\:justify-evenly {
    justify-content: space-evenly;
  }

  .md\\:space-x-2xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
  }

  .md\\:space-y-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
  }

  .md\\:space-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
  }

  .md\\:space-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
  }

  .md\\:space-y-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
  }

  .md\\:space-y-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxl) * var(--tw-space-y-reverse));
  }

  .md\\:space-y-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxs) * var(--tw-space-y-reverse));
  }

  .md\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-base) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-base) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:divide-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-lg) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:divide-x-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-md) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-md) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:divide-x-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-none) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-none) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:divide-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-xl) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-base) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-base) * var(--tw-divide-y-reverse));
  }

  .md\\:divide-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-lg) * var(--tw-divide-y-reverse));
  }

  .md\\:divide-y-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-md) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-md) * var(--tw-divide-y-reverse));
  }

  .md\\:divide-y-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-none) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-none) * var(--tw-divide-y-reverse));
  }

  .md\\:divide-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-xl) * var(--tw-divide-y-reverse));
  }

  .md\\:divide-current > :not([hidden]) ~ :not([hidden]) {
    border-color: currentColor;
  }

  .md\\:divide-transparent > :not([hidden]) ~ :not([hidden]) {
    border-color: transparent;
  }

  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .md\\:rounded-full {
    border-radius: 9999px;
  }

  .md\\:rounded-lg {
    border-radius: var(--border-radius-lg);
  }

  .md\\:rounded-md {
    border-radius: var(--border-radius-md);
  }

  .md\\:rounded-none {
    border-radius: var(--border-radius-none);
  }

  .md\\:rounded-xl {
    border-radius: var(--border-radius-xl);
  }

  .md\\:rounded-xxl {
    border-radius: var(--border-radius-xxl);
  }

  .md\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .md\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .md\\:rounded-b-lg {
    border-bottom-right-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .md\\:rounded-b-md {
    border-bottom-right-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .md\\:rounded-b-none {
    border-bottom-right-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .md\\:rounded-b-xl {
    border-bottom-right-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .md\\:rounded-b-xxl {
    border-bottom-right-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .md\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .md\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .md\\:rounded-l-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .md\\:rounded-l-md {
    border-top-left-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .md\\:rounded-l-none {
    border-top-left-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .md\\:rounded-l-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .md\\:rounded-l-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .md\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .md\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .md\\:rounded-r-lg {
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);
  }

  .md\\:rounded-r-md {
    border-top-right-radius: var(--border-radius-md);
    border-bottom-right-radius: var(--border-radius-md);
  }

  .md\\:rounded-r-none {
    border-top-right-radius: var(--border-radius-none);
    border-bottom-right-radius: var(--border-radius-none);
  }

  .md\\:rounded-r-xl {
    border-top-right-radius: var(--border-radius-xl);
    border-bottom-right-radius: var(--border-radius-xl);
  }

  .md\\:rounded-r-xxl {
    border-top-right-radius: var(--border-radius-xxl);
    border-bottom-right-radius: var(--border-radius-xxl);
  }

  .md\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .md\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .md\\:rounded-t-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-top-right-radius: var(--border-radius-lg);
  }

  .md\\:rounded-t-md {
    border-top-left-radius: var(--border-radius-md);
    border-top-right-radius: var(--border-radius-md);
  }

  .md\\:rounded-t-none {
    border-top-left-radius: var(--border-radius-none);
    border-top-right-radius: var(--border-radius-none);
  }

  .md\\:rounded-t-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-top-right-radius: var(--border-radius-xl);
  }

  .md\\:rounded-t-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-top-right-radius: var(--border-radius-xxl);
  }

  .md\\:border {
    border-width: var(--border-base);
  }

  .md\\:border-lg {
    border-width: var(--border-lg);
  }

  .md\\:border-md {
    border-width: var(--border-md);
  }

  .md\\:border-none {
    border-width: var(--border-none);
  }

  .md\\:border-xl {
    border-width: var(--border-xl);
  }

  .md\\:border-b {
    border-bottom-width: var(--border-base);
  }

  .md\\:border-b-lg {
    border-bottom-width: var(--border-lg);
  }

  .md\\:border-b-md {
    border-bottom-width: var(--border-md);
  }

  .md\\:border-b-none {
    border-bottom-width: var(--border-none);
  }

  .md\\:border-b-xl {
    border-bottom-width: var(--border-xl);
  }

  .md\\:border-l {
    border-left-width: var(--border-base);
  }

  .md\\:border-l-lg {
    border-left-width: var(--border-lg);
  }

  .md\\:border-l-md {
    border-left-width: var(--border-md);
  }

  .md\\:border-l-none {
    border-left-width: var(--border-none);
  }

  .md\\:border-l-xl {
    border-left-width: var(--border-xl);
  }

  .md\\:border-r {
    border-right-width: var(--border-base);
  }

  .md\\:border-r-lg {
    border-right-width: var(--border-lg);
  }

  .md\\:border-r-md {
    border-right-width: var(--border-md);
  }

  .md\\:border-r-none {
    border-right-width: var(--border-none);
  }

  .md\\:border-r-xl {
    border-right-width: var(--border-xl);
  }

  .md\\:border-t {
    border-top-width: var(--border-base);
  }

  .md\\:border-t-lg {
    border-top-width: var(--border-lg);
  }

  .md\\:border-t-md {
    border-top-width: var(--border-md);
  }

  .md\\:border-t-none {
    border-top-width: var(--border-none);
  }

  .md\\:border-t-xl {
    border-top-width: var(--border-xl);
  }

  .md\\:border-none {
    border-style: none;
  }

  .md\\:border-border {
    border-color: var(--color-border);
  }

  .md\\:border-caution {
    border-color: var(--color-caution);
  }

  .md\\:border-critical {
    border-color: var(--color-critical);
  }

  .md\\:border-current {
    border-color: currentColor;
  }

  .md\\:border-info {
    border-color: var(--color-info);
  }

  .md\\:border-main {
    border-color: var(--color-main);
  }

  .md\\:border-neutral {
    border-color: var(--color-neutral);
  }

  .md\\:border-positive {
    border-color: var(--color-positive);
  }

  .md\\:border-transparent {
    border-color: transparent;
  }

  .md\\:bg-background {
    background-color: var(--color-background);
  }

  .md\\:bg-surface {
    background-color: var(--color-surface);
  }

  .md\\:bg-surface-strong {
    background-color: var(--color-surface-strong);
  }

  .md\\:bg-surface-subtle {
    background-color: var(--color-surface-subtle);
  }

  .md\\:bg-opacity-90 {
    --tw-bg-opacity: 0.9;
  }

  .md\\:p-2xs {
    padding: var(--spacing-2xs);
  }

  .md\\:p-base {
    padding: var(--spacing-base);
  }

  .md\\:p-lg {
    padding: var(--spacing-lg);
  }

  .md\\:p-xl {
    padding: var(--spacing-xl);
  }

  .md\\:p-xs {
    padding: var(--spacing-xs);
  }

  .md\\:p-xxl {
    padding: var(--spacing-xxl);
  }

  .md\\:px-2xs {
    padding-left: var(--spacing-2xs);
    padding-right: var(--spacing-2xs);
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:px-base {
    padding-left: var(--spacing-base);
    padding-right: var(--spacing-base);
  }

  .md\\:px-lg {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  .md\\:px-xl {
    padding-left: var(--spacing-xl);
    padding-right: var(--spacing-xl);
  }

  .md\\:px-xs {
    padding-left: var(--spacing-xs);
    padding-right: var(--spacing-xs);
  }

  .md\\:px-xxl {
    padding-left: var(--spacing-xxl);
    padding-right: var(--spacing-xxl);
  }

  .md\\:py-2xs {
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .md\\:py-36 {
    padding-top: 9rem;
    padding-bottom: 9rem;
  }

  .md\\:py-base {
    padding-top: var(--spacing-base);
    padding-bottom: var(--spacing-base);
  }

  .md\\:py-lg {
    padding-top: var(--spacing-lg);
    padding-bottom: var(--spacing-lg);
  }

  .md\\:py-xl {
    padding-top: var(--spacing-xl);
    padding-bottom: var(--spacing-xl);
  }

  .md\\:py-xs {
    padding-top: var(--spacing-xs);
    padding-bottom: var(--spacing-xs);
  }

  .md\\:py-xxl {
    padding-top: var(--spacing-xxl);
    padding-bottom: var(--spacing-xxl);
  }

  .md\\:pb-2xs {
    padding-bottom: var(--spacing-2xs);
  }

  .md\\:pb-base {
    padding-bottom: var(--spacing-base);
  }

  .md\\:pb-lg {
    padding-bottom: var(--spacing-lg);
  }

  .md\\:pb-xl {
    padding-bottom: var(--spacing-xl);
  }

  .md\\:pb-xs {
    padding-bottom: var(--spacing-xs);
  }

  .md\\:pb-xxl {
    padding-bottom: var(--spacing-xxl);
  }

  .md\\:pl-10 {
    padding-left: 2.5rem;
  }

  .md\\:pl-2xs {
    padding-left: var(--spacing-2xs);
  }

  .md\\:pl-base {
    padding-left: var(--spacing-base);
  }

  .md\\:pl-lg {
    padding-left: var(--spacing-lg);
  }

  .md\\:pl-xl {
    padding-left: var(--spacing-xl);
  }

  .md\\:pl-xs {
    padding-left: var(--spacing-xs);
  }

  .md\\:pl-xxl {
    padding-left: var(--spacing-xxl);
  }

  .md\\:pr-2xs {
    padding-right: var(--spacing-2xs);
  }

  .md\\:pr-base {
    padding-right: var(--spacing-base);
  }

  .md\\:pr-lg {
    padding-right: var(--spacing-lg);
  }

  .md\\:pr-xl {
    padding-right: var(--spacing-xl);
  }

  .md\\:pr-xs {
    padding-right: var(--spacing-xs);
  }

  .md\\:pr-xxl {
    padding-right: var(--spacing-xxl);
  }

  .md\\:pt-2xs {
    padding-top: var(--spacing-2xs);
  }

  .md\\:pt-base {
    padding-top: var(--spacing-base);
  }

  .md\\:pt-lg {
    padding-top: var(--spacing-lg);
  }

  .md\\:pt-xl {
    padding-top: var(--spacing-xl);
  }

  .md\\:pt-xs {
    padding-top: var(--spacing-xs);
  }

  .md\\:pt-xxl {
    padding-top: var(--spacing-xxl);
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-base {
    font-size: var(--size-text);
    line-height: var(--line-height-text);
  }

  .md\\:text-lg {
    font-size: var(--size-text-lg);
    line-height: var(--line-height-text-lg);
  }

  .md\\:text-sm {
    font-size: var(--size-text-sm);
    line-height: var(--line-height-text-sm);
  }

  .md\\:text-color {
    color: var(--color-text);
  }

  .md\\:text-color-caution {
    color: var(--color-caution);
  }

  .md\\:text-color-critical {
    color: var(--color-critical);
  }

  .md\\:text-color-info {
    color: var(--color-info);
  }

  .md\\:text-color-main {
    color: var(--color-main);
  }

  .md\\:text-color-neutral {
    color: var(--color-neutral);
  }

  .md\\:text-color-positive {
    color: var(--color-positive);
  }

  .md\\:text-color-semantic {
    color: var(--color-text-semantic);
  }

  .md\\:text-color-strong {
    color: var(--color-text-strong);
  }

  .md\\:text-color-subtle {
    color: var(--color-text-subtle);
  }
}
@media (min-width: 1024px) {

  .lg\\:m-2xs {
    margin: var(--spacing-2xs);
  }

  .lg\\:m-base {
    margin: var(--spacing-base);
  }

  .lg\\:m-lg {
    margin: var(--spacing-lg);
  }

  .lg\\:m-xl {
    margin: var(--spacing-xl);
  }

  .lg\\:m-xs {
    margin: var(--spacing-xs);
  }

  .lg\\:m-xxl {
    margin: var(--spacing-xxl);
  }

  .lg\\:mx-2xs {
    margin-left: var(--spacing-2xs);
    margin-right: var(--spacing-2xs);
  }

  .lg\\:mx-base {
    margin-left: var(--spacing-base);
    margin-right: var(--spacing-base);
  }

  .lg\\:mx-lg {
    margin-left: var(--spacing-lg);
    margin-right: var(--spacing-lg);
  }

  .lg\\:mx-xl {
    margin-left: var(--spacing-xl);
    margin-right: var(--spacing-xl);
  }

  .lg\\:mx-xs {
    margin-left: var(--spacing-xs);
    margin-right: var(--spacing-xs);
  }

  .lg\\:mx-xxl {
    margin-left: var(--spacing-xxl);
    margin-right: var(--spacing-xxl);
  }

  .lg\\:my-2xs {
    margin-top: var(--spacing-2xs);
    margin-bottom: var(--spacing-2xs);
  }

  .lg\\:my-base {
    margin-top: var(--spacing-base);
    margin-bottom: var(--spacing-base);
  }

  .lg\\:my-lg {
    margin-top: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  .lg\\:my-xl {
    margin-top: var(--spacing-xl);
    margin-bottom: var(--spacing-xl);
  }

  .lg\\:my-xs {
    margin-top: var(--spacing-xs);
    margin-bottom: var(--spacing-xs);
  }

  .lg\\:my-xxl {
    margin-top: var(--spacing-xxl);
    margin-bottom: var(--spacing-xxl);
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-2xs {
    margin-bottom: var(--spacing-2xs);
  }

  .lg\\:mb-base {
    margin-bottom: var(--spacing-base);
  }

  .lg\\:mb-lg {
    margin-bottom: var(--spacing-lg);
  }

  .lg\\:mb-xl {
    margin-bottom: var(--spacing-xl);
  }

  .lg\\:mb-xs {
    margin-bottom: var(--spacing-xs);
  }

  .lg\\:mb-xxl {
    margin-bottom: var(--spacing-xxl);
  }

  .lg\\:ml-2xs {
    margin-left: var(--spacing-2xs);
  }

  .lg\\:ml-base {
    margin-left: var(--spacing-base);
  }

  .lg\\:ml-lg {
    margin-left: var(--spacing-lg);
  }

  .lg\\:ml-xl {
    margin-left: var(--spacing-xl);
  }

  .lg\\:ml-xs {
    margin-left: var(--spacing-xs);
  }

  .lg\\:ml-xxl {
    margin-left: var(--spacing-xxl);
  }

  .lg\\:mr-2xs {
    margin-right: var(--spacing-2xs);
  }

  .lg\\:mr-base {
    margin-right: var(--spacing-base);
  }

  .lg\\:mr-lg {
    margin-right: var(--spacing-lg);
  }

  .lg\\:mr-xl {
    margin-right: var(--spacing-xl);
  }

  .lg\\:mr-xs {
    margin-right: var(--spacing-xs);
  }

  .lg\\:mr-xxl {
    margin-right: var(--spacing-xxl);
  }

  .lg\\:mt-2xs {
    margin-top: var(--spacing-2xs);
  }

  .lg\\:mt-base {
    margin-top: var(--spacing-base);
  }

  .lg\\:mt-lg {
    margin-top: var(--spacing-lg);
  }

  .lg\\:mt-xl {
    margin-top: var(--spacing-xl);
  }

  .lg\\:mt-xs {
    margin-top: var(--spacing-xs);
  }

  .lg\\:mt-xxl {
    margin-top: var(--spacing-xxl);
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-1\\/12 {
    width: 8.333333%;
  }

  .lg\\:w-10\\/12 {
    width: 83.333333%;
  }

  .lg\\:w-11\\/12 {
    width: 91.666667%;
  }

  .lg\\:w-2\\/12 {
    width: 16.666667%;
  }

  .lg\\:w-3\\/12 {
    width: 25%;
  }

  .lg\\:w-4\\/12 {
    width: 33.333333%;
  }

  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }

  .lg\\:w-6\\/12 {
    width: 50%;
  }

  .lg\\:w-7\\/12 {
    width: 58.333333%;
  }

  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }

  .lg\\:w-9\\/12 {
    width: 75%;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:w-max {
    width: max-content;
  }

  .lg\\:w-min {
    width: min-content;
  }

  .lg\\:w-screen {
    width: 100vw;
  }

  .lg\\:flex-grow {
    flex-grow: 1;
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:items-baseline {
    align-items: baseline;
  }

  .lg\\:items-stretch {
    align-items: stretch;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:justify-around {
    justify-content: space-around;
  }

  .lg\\:justify-evenly {
    justify-content: space-evenly;
  }

  .lg\\:space-x-2xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-y-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxl) * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxs) * var(--tw-space-y-reverse));
  }

  .lg\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-base) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-base) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .lg\\:divide-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-lg) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .lg\\:divide-x-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-md) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-md) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .lg\\:divide-x-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-none) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-none) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .lg\\:divide-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-xl) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .lg\\:divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-base) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-base) * var(--tw-divide-y-reverse));
  }

  .lg\\:divide-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-lg) * var(--tw-divide-y-reverse));
  }

  .lg\\:divide-y-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-md) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-md) * var(--tw-divide-y-reverse));
  }

  .lg\\:divide-y-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-none) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-none) * var(--tw-divide-y-reverse));
  }

  .lg\\:divide-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-xl) * var(--tw-divide-y-reverse));
  }

  .lg\\:divide-current > :not([hidden]) ~ :not([hidden]) {
    border-color: currentColor;
  }

  .lg\\:divide-transparent > :not([hidden]) ~ :not([hidden]) {
    border-color: transparent;
  }

  .lg\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .lg\\:rounded-full {
    border-radius: 9999px;
  }

  .lg\\:rounded-lg {
    border-radius: var(--border-radius-lg);
  }

  .lg\\:rounded-md {
    border-radius: var(--border-radius-md);
  }

  .lg\\:rounded-none {
    border-radius: var(--border-radius-none);
  }

  .lg\\:rounded-xl {
    border-radius: var(--border-radius-xl);
  }

  .lg\\:rounded-xxl {
    border-radius: var(--border-radius-xxl);
  }

  .lg\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .lg\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .lg\\:rounded-b-lg {
    border-bottom-right-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .lg\\:rounded-b-md {
    border-bottom-right-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .lg\\:rounded-b-none {
    border-bottom-right-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .lg\\:rounded-b-xl {
    border-bottom-right-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .lg\\:rounded-b-xxl {
    border-bottom-right-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .lg\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .lg\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .lg\\:rounded-l-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .lg\\:rounded-l-md {
    border-top-left-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .lg\\:rounded-l-none {
    border-top-left-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .lg\\:rounded-l-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .lg\\:rounded-l-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .lg\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .lg\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .lg\\:rounded-r-lg {
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);
  }

  .lg\\:rounded-r-md {
    border-top-right-radius: var(--border-radius-md);
    border-bottom-right-radius: var(--border-radius-md);
  }

  .lg\\:rounded-r-none {
    border-top-right-radius: var(--border-radius-none);
    border-bottom-right-radius: var(--border-radius-none);
  }

  .lg\\:rounded-r-xl {
    border-top-right-radius: var(--border-radius-xl);
    border-bottom-right-radius: var(--border-radius-xl);
  }

  .lg\\:rounded-r-xxl {
    border-top-right-radius: var(--border-radius-xxl);
    border-bottom-right-radius: var(--border-radius-xxl);
  }

  .lg\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .lg\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .lg\\:rounded-t-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-top-right-radius: var(--border-radius-lg);
  }

  .lg\\:rounded-t-md {
    border-top-left-radius: var(--border-radius-md);
    border-top-right-radius: var(--border-radius-md);
  }

  .lg\\:rounded-t-none {
    border-top-left-radius: var(--border-radius-none);
    border-top-right-radius: var(--border-radius-none);
  }

  .lg\\:rounded-t-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-top-right-radius: var(--border-radius-xl);
  }

  .lg\\:rounded-t-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-top-right-radius: var(--border-radius-xxl);
  }

  .lg\\:border {
    border-width: var(--border-base);
  }

  .lg\\:border-lg {
    border-width: var(--border-lg);
  }

  .lg\\:border-md {
    border-width: var(--border-md);
  }

  .lg\\:border-none {
    border-width: var(--border-none);
  }

  .lg\\:border-xl {
    border-width: var(--border-xl);
  }

  .lg\\:border-b {
    border-bottom-width: var(--border-base);
  }

  .lg\\:border-b-lg {
    border-bottom-width: var(--border-lg);
  }

  .lg\\:border-b-md {
    border-bottom-width: var(--border-md);
  }

  .lg\\:border-b-none {
    border-bottom-width: var(--border-none);
  }

  .lg\\:border-b-xl {
    border-bottom-width: var(--border-xl);
  }

  .lg\\:border-l {
    border-left-width: var(--border-base);
  }

  .lg\\:border-l-lg {
    border-left-width: var(--border-lg);
  }

  .lg\\:border-l-md {
    border-left-width: var(--border-md);
  }

  .lg\\:border-l-none {
    border-left-width: var(--border-none);
  }

  .lg\\:border-l-xl {
    border-left-width: var(--border-xl);
  }

  .lg\\:border-r {
    border-right-width: var(--border-base);
  }

  .lg\\:border-r-lg {
    border-right-width: var(--border-lg);
  }

  .lg\\:border-r-md {
    border-right-width: var(--border-md);
  }

  .lg\\:border-r-none {
    border-right-width: var(--border-none);
  }

  .lg\\:border-r-xl {
    border-right-width: var(--border-xl);
  }

  .lg\\:border-t {
    border-top-width: var(--border-base);
  }

  .lg\\:border-t-lg {
    border-top-width: var(--border-lg);
  }

  .lg\\:border-t-md {
    border-top-width: var(--border-md);
  }

  .lg\\:border-t-none {
    border-top-width: var(--border-none);
  }

  .lg\\:border-t-xl {
    border-top-width: var(--border-xl);
  }

  .lg\\:border-none {
    border-style: none;
  }

  .lg\\:border-border {
    border-color: var(--color-border);
  }

  .lg\\:border-caution {
    border-color: var(--color-caution);
  }

  .lg\\:border-critical {
    border-color: var(--color-critical);
  }

  .lg\\:border-current {
    border-color: currentColor;
  }

  .lg\\:border-info {
    border-color: var(--color-info);
  }

  .lg\\:border-main {
    border-color: var(--color-main);
  }

  .lg\\:border-neutral {
    border-color: var(--color-neutral);
  }

  .lg\\:border-positive {
    border-color: var(--color-positive);
  }

  .lg\\:border-transparent {
    border-color: transparent;
  }

  .lg\\:bg-background {
    background-color: var(--color-background);
  }

  .lg\\:bg-surface {
    background-color: var(--color-surface);
  }

  .lg\\:bg-surface-strong {
    background-color: var(--color-surface-strong);
  }

  .lg\\:bg-surface-subtle {
    background-color: var(--color-surface-subtle);
  }

  .lg\\:p-2xs {
    padding: var(--spacing-2xs);
  }

  .lg\\:p-base {
    padding: var(--spacing-base);
  }

  .lg\\:p-lg {
    padding: var(--spacing-lg);
  }

  .lg\\:p-xl {
    padding: var(--spacing-xl);
  }

  .lg\\:p-xs {
    padding: var(--spacing-xs);
  }

  .lg\\:p-xxl {
    padding: var(--spacing-xxl);
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:px-2xs {
    padding-left: var(--spacing-2xs);
    padding-right: var(--spacing-2xs);
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-base {
    padding-left: var(--spacing-base);
    padding-right: var(--spacing-base);
  }

  .lg\\:px-lg {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  .lg\\:px-xl {
    padding-left: var(--spacing-xl);
    padding-right: var(--spacing-xl);
  }

  .lg\\:px-xs {
    padding-left: var(--spacing-xs);
    padding-right: var(--spacing-xs);
  }

  .lg\\:px-xxl {
    padding-left: var(--spacing-xxl);
    padding-right: var(--spacing-xxl);
  }

  .lg\\:py-2xs {
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .lg\\:py-base {
    padding-top: var(--spacing-base);
    padding-bottom: var(--spacing-base);
  }

  .lg\\:py-lg {
    padding-top: var(--spacing-lg);
    padding-bottom: var(--spacing-lg);
  }

  .lg\\:py-xl {
    padding-top: var(--spacing-xl);
    padding-bottom: var(--spacing-xl);
  }

  .lg\\:py-xs {
    padding-top: var(--spacing-xs);
    padding-bottom: var(--spacing-xs);
  }

  .lg\\:py-xxl {
    padding-top: var(--spacing-xxl);
    padding-bottom: var(--spacing-xxl);
  }

  .lg\\:pb-2xs {
    padding-bottom: var(--spacing-2xs);
  }

  .lg\\:pb-base {
    padding-bottom: var(--spacing-base);
  }

  .lg\\:pb-lg {
    padding-bottom: var(--spacing-lg);
  }

  .lg\\:pb-xl {
    padding-bottom: var(--spacing-xl);
  }

  .lg\\:pb-xs {
    padding-bottom: var(--spacing-xs);
  }

  .lg\\:pb-xxl {
    padding-bottom: var(--spacing-xxl);
  }

  .lg\\:pl-2xs {
    padding-left: var(--spacing-2xs);
  }

  .lg\\:pl-base {
    padding-left: var(--spacing-base);
  }

  .lg\\:pl-lg {
    padding-left: var(--spacing-lg);
  }

  .lg\\:pl-xl {
    padding-left: var(--spacing-xl);
  }

  .lg\\:pl-xs {
    padding-left: var(--spacing-xs);
  }

  .lg\\:pl-xxl {
    padding-left: var(--spacing-xxl);
  }

  .lg\\:pr-2xs {
    padding-right: var(--spacing-2xs);
  }

  .lg\\:pr-base {
    padding-right: var(--spacing-base);
  }

  .lg\\:pr-lg {
    padding-right: var(--spacing-lg);
  }

  .lg\\:pr-xl {
    padding-right: var(--spacing-xl);
  }

  .lg\\:pr-xs {
    padding-right: var(--spacing-xs);
  }

  .lg\\:pr-xxl {
    padding-right: var(--spacing-xxl);
  }

  .lg\\:pt-2xs {
    padding-top: var(--spacing-2xs);
  }

  .lg\\:pt-base {
    padding-top: var(--spacing-base);
  }

  .lg\\:pt-lg {
    padding-top: var(--spacing-lg);
  }

  .lg\\:pt-xl {
    padding-top: var(--spacing-xl);
  }

  .lg\\:pt-xs {
    padding-top: var(--spacing-xs);
  }

  .lg\\:pt-xxl {
    padding-top: var(--spacing-xxl);
  }

  .lg\\:text-center {
    text-align: center;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-base {
    font-size: var(--size-text);
    line-height: var(--line-height-text);
  }

  .lg\\:text-lg {
    font-size: var(--size-text-lg);
    line-height: var(--line-height-text-lg);
  }

  .lg\\:text-sm {
    font-size: var(--size-text-sm);
    line-height: var(--line-height-text-sm);
  }

  .lg\\:text-color {
    color: var(--color-text);
  }

  .lg\\:text-color-caution {
    color: var(--color-caution);
  }

  .lg\\:text-color-critical {
    color: var(--color-critical);
  }

  .lg\\:text-color-info {
    color: var(--color-info);
  }

  .lg\\:text-color-main {
    color: var(--color-main);
  }

  .lg\\:text-color-neutral {
    color: var(--color-neutral);
  }

  .lg\\:text-color-positive {
    color: var(--color-positive);
  }

  .lg\\:text-color-semantic {
    color: var(--color-text-semantic);
  }

  .lg\\:text-color-strong {
    color: var(--color-text-strong);
  }

  .lg\\:text-color-subtle {
    color: var(--color-text-subtle);
  }
}
@media (min-width: 1280px) {

  .xl\\:m-2xs {
    margin: var(--spacing-2xs);
  }

  .xl\\:m-base {
    margin: var(--spacing-base);
  }

  .xl\\:m-lg {
    margin: var(--spacing-lg);
  }

  .xl\\:m-xl {
    margin: var(--spacing-xl);
  }

  .xl\\:m-xs {
    margin: var(--spacing-xs);
  }

  .xl\\:m-xxl {
    margin: var(--spacing-xxl);
  }

  .xl\\:mx-2xs {
    margin-left: var(--spacing-2xs);
    margin-right: var(--spacing-2xs);
  }

  .xl\\:mx-base {
    margin-left: var(--spacing-base);
    margin-right: var(--spacing-base);
  }

  .xl\\:mx-lg {
    margin-left: var(--spacing-lg);
    margin-right: var(--spacing-lg);
  }

  .xl\\:mx-xl {
    margin-left: var(--spacing-xl);
    margin-right: var(--spacing-xl);
  }

  .xl\\:mx-xs {
    margin-left: var(--spacing-xs);
    margin-right: var(--spacing-xs);
  }

  .xl\\:mx-xxl {
    margin-left: var(--spacing-xxl);
    margin-right: var(--spacing-xxl);
  }

  .xl\\:my-2xs {
    margin-top: var(--spacing-2xs);
    margin-bottom: var(--spacing-2xs);
  }

  .xl\\:my-base {
    margin-top: var(--spacing-base);
    margin-bottom: var(--spacing-base);
  }

  .xl\\:my-lg {
    margin-top: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  .xl\\:my-xl {
    margin-top: var(--spacing-xl);
    margin-bottom: var(--spacing-xl);
  }

  .xl\\:my-xs {
    margin-top: var(--spacing-xs);
    margin-bottom: var(--spacing-xs);
  }

  .xl\\:my-xxl {
    margin-top: var(--spacing-xxl);
    margin-bottom: var(--spacing-xxl);
  }

  .xl\\:mb-2xs {
    margin-bottom: var(--spacing-2xs);
  }

  .xl\\:mb-base {
    margin-bottom: var(--spacing-base);
  }

  .xl\\:mb-lg {
    margin-bottom: var(--spacing-lg);
  }

  .xl\\:mb-xl {
    margin-bottom: var(--spacing-xl);
  }

  .xl\\:mb-xs {
    margin-bottom: var(--spacing-xs);
  }

  .xl\\:mb-xxl {
    margin-bottom: var(--spacing-xxl);
  }

  .xl\\:ml-2xs {
    margin-left: var(--spacing-2xs);
  }

  .xl\\:ml-base {
    margin-left: var(--spacing-base);
  }

  .xl\\:ml-lg {
    margin-left: var(--spacing-lg);
  }

  .xl\\:ml-xl {
    margin-left: var(--spacing-xl);
  }

  .xl\\:ml-xs {
    margin-left: var(--spacing-xs);
  }

  .xl\\:ml-xxl {
    margin-left: var(--spacing-xxl);
  }

  .xl\\:mr-2xs {
    margin-right: var(--spacing-2xs);
  }

  .xl\\:mr-44 {
    margin-right: 11rem;
  }

  .xl\\:mr-base {
    margin-right: var(--spacing-base);
  }

  .xl\\:mr-lg {
    margin-right: var(--spacing-lg);
  }

  .xl\\:mr-xl {
    margin-right: var(--spacing-xl);
  }

  .xl\\:mr-xs {
    margin-right: var(--spacing-xs);
  }

  .xl\\:mr-xxl {
    margin-right: var(--spacing-xxl);
  }

  .xl\\:mt-2xs {
    margin-top: var(--spacing-2xs);
  }

  .xl\\:mt-base {
    margin-top: var(--spacing-base);
  }

  .xl\\:mt-lg {
    margin-top: var(--spacing-lg);
  }

  .xl\\:mt-xl {
    margin-top: var(--spacing-xl);
  }

  .xl\\:mt-xs {
    margin-top: var(--spacing-xs);
  }

  .xl\\:mt-xxl {
    margin-top: var(--spacing-xxl);
  }

  .xl\\:h-auto {
    height: auto;
  }

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:h-screen {
    height: 100vh;
  }

  .xl\\:w-1\\/12 {
    width: 8.333333%;
  }

  .xl\\:w-10\\/12 {
    width: 83.333333%;
  }

  .xl\\:w-11\\/12 {
    width: 91.666667%;
  }

  .xl\\:w-2\\/12 {
    width: 16.666667%;
  }

  .xl\\:w-3\\/12 {
    width: 25%;
  }

  .xl\\:w-3\\/4 {
    width: 75%;
  }

  .xl\\:w-4\\/12 {
    width: 33.333333%;
  }

  .xl\\:w-5\\/12 {
    width: 41.666667%;
  }

  .xl\\:w-6\\/12 {
    width: 50%;
  }

  .xl\\:w-7\\/12 {
    width: 58.333333%;
  }

  .xl\\:w-8\\/12 {
    width: 66.666667%;
  }

  .xl\\:w-9\\/12 {
    width: 75%;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:w-max {
    width: max-content;
  }

  .xl\\:w-min {
    width: min-content;
  }

  .xl\\:w-screen {
    width: 100vw;
  }

  .xl\\:max-w-6xl {
    max-width: 72rem;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:items-end {
    align-items: flex-end;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:items-baseline {
    align-items: baseline;
  }

  .xl\\:items-stretch {
    align-items: stretch;
  }

  .xl\\:justify-start {
    justify-content: flex-start;
  }

  .xl\\:justify-end {
    justify-content: flex-end;
  }

  .xl\\:justify-center {
    justify-content: center;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:justify-around {
    justify-content: space-around;
  }

  .xl\\:justify-evenly {
    justify-content: space-evenly;
  }

  .xl\\:space-x-2xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-x-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-y-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxl) * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxs) * var(--tw-space-y-reverse));
  }

  .xl\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-base) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-base) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xl\\:divide-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-lg) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xl\\:divide-x-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-md) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-md) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xl\\:divide-x-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-none) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-none) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xl\\:divide-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-xl) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xl\\:divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-base) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-base) * var(--tw-divide-y-reverse));
  }

  .xl\\:divide-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-lg) * var(--tw-divide-y-reverse));
  }

  .xl\\:divide-y-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-md) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-md) * var(--tw-divide-y-reverse));
  }

  .xl\\:divide-y-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-none) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-none) * var(--tw-divide-y-reverse));
  }

  .xl\\:divide-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-xl) * var(--tw-divide-y-reverse));
  }

  .xl\\:divide-current > :not([hidden]) ~ :not([hidden]) {
    border-color: currentColor;
  }

  .xl\\:divide-transparent > :not([hidden]) ~ :not([hidden]) {
    border-color: transparent;
  }

  .xl\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .xl\\:rounded-full {
    border-radius: 9999px;
  }

  .xl\\:rounded-lg {
    border-radius: var(--border-radius-lg);
  }

  .xl\\:rounded-md {
    border-radius: var(--border-radius-md);
  }

  .xl\\:rounded-none {
    border-radius: var(--border-radius-none);
  }

  .xl\\:rounded-xl {
    border-radius: var(--border-radius-xl);
  }

  .xl\\:rounded-xxl {
    border-radius: var(--border-radius-xxl);
  }

  .xl\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .xl\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xl\\:rounded-b-lg {
    border-bottom-right-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .xl\\:rounded-b-md {
    border-bottom-right-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .xl\\:rounded-b-none {
    border-bottom-right-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .xl\\:rounded-b-xl {
    border-bottom-right-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .xl\\:rounded-b-xxl {
    border-bottom-right-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .xl\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .xl\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xl\\:rounded-l-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .xl\\:rounded-l-md {
    border-top-left-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .xl\\:rounded-l-none {
    border-top-left-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .xl\\:rounded-l-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .xl\\:rounded-l-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .xl\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .xl\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .xl\\:rounded-r-lg {
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);
  }

  .xl\\:rounded-r-md {
    border-top-right-radius: var(--border-radius-md);
    border-bottom-right-radius: var(--border-radius-md);
  }

  .xl\\:rounded-r-none {
    border-top-right-radius: var(--border-radius-none);
    border-bottom-right-radius: var(--border-radius-none);
  }

  .xl\\:rounded-r-xl {
    border-top-right-radius: var(--border-radius-xl);
    border-bottom-right-radius: var(--border-radius-xl);
  }

  .xl\\:rounded-r-xxl {
    border-top-right-radius: var(--border-radius-xxl);
    border-bottom-right-radius: var(--border-radius-xxl);
  }

  .xl\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .xl\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .xl\\:rounded-t-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-top-right-radius: var(--border-radius-lg);
  }

  .xl\\:rounded-t-md {
    border-top-left-radius: var(--border-radius-md);
    border-top-right-radius: var(--border-radius-md);
  }

  .xl\\:rounded-t-none {
    border-top-left-radius: var(--border-radius-none);
    border-top-right-radius: var(--border-radius-none);
  }

  .xl\\:rounded-t-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-top-right-radius: var(--border-radius-xl);
  }

  .xl\\:rounded-t-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-top-right-radius: var(--border-radius-xxl);
  }

  .xl\\:border {
    border-width: var(--border-base);
  }

  .xl\\:border-lg {
    border-width: var(--border-lg);
  }

  .xl\\:border-md {
    border-width: var(--border-md);
  }

  .xl\\:border-none {
    border-width: var(--border-none);
  }

  .xl\\:border-xl {
    border-width: var(--border-xl);
  }

  .xl\\:border-b {
    border-bottom-width: var(--border-base);
  }

  .xl\\:border-b-lg {
    border-bottom-width: var(--border-lg);
  }

  .xl\\:border-b-md {
    border-bottom-width: var(--border-md);
  }

  .xl\\:border-b-none {
    border-bottom-width: var(--border-none);
  }

  .xl\\:border-b-xl {
    border-bottom-width: var(--border-xl);
  }

  .xl\\:border-l {
    border-left-width: var(--border-base);
  }

  .xl\\:border-l-lg {
    border-left-width: var(--border-lg);
  }

  .xl\\:border-l-md {
    border-left-width: var(--border-md);
  }

  .xl\\:border-l-none {
    border-left-width: var(--border-none);
  }

  .xl\\:border-l-xl {
    border-left-width: var(--border-xl);
  }

  .xl\\:border-r {
    border-right-width: var(--border-base);
  }

  .xl\\:border-r-lg {
    border-right-width: var(--border-lg);
  }

  .xl\\:border-r-md {
    border-right-width: var(--border-md);
  }

  .xl\\:border-r-none {
    border-right-width: var(--border-none);
  }

  .xl\\:border-r-xl {
    border-right-width: var(--border-xl);
  }

  .xl\\:border-t {
    border-top-width: var(--border-base);
  }

  .xl\\:border-t-lg {
    border-top-width: var(--border-lg);
  }

  .xl\\:border-t-md {
    border-top-width: var(--border-md);
  }

  .xl\\:border-t-none {
    border-top-width: var(--border-none);
  }

  .xl\\:border-t-xl {
    border-top-width: var(--border-xl);
  }

  .xl\\:border-none {
    border-style: none;
  }

  .xl\\:border-border {
    border-color: var(--color-border);
  }

  .xl\\:border-caution {
    border-color: var(--color-caution);
  }

  .xl\\:border-critical {
    border-color: var(--color-critical);
  }

  .xl\\:border-current {
    border-color: currentColor;
  }

  .xl\\:border-info {
    border-color: var(--color-info);
  }

  .xl\\:border-main {
    border-color: var(--color-main);
  }

  .xl\\:border-neutral {
    border-color: var(--color-neutral);
  }

  .xl\\:border-positive {
    border-color: var(--color-positive);
  }

  .xl\\:border-transparent {
    border-color: transparent;
  }

  .xl\\:bg-background {
    background-color: var(--color-background);
  }

  .xl\\:bg-surface {
    background-color: var(--color-surface);
  }

  .xl\\:bg-surface-strong {
    background-color: var(--color-surface-strong);
  }

  .xl\\:bg-surface-subtle {
    background-color: var(--color-surface-subtle);
  }

  .xl\\:p-2xs {
    padding: var(--spacing-2xs);
  }

  .xl\\:p-base {
    padding: var(--spacing-base);
  }

  .xl\\:p-lg {
    padding: var(--spacing-lg);
  }

  .xl\\:p-xl {
    padding: var(--spacing-xl);
  }

  .xl\\:p-xs {
    padding: var(--spacing-xs);
  }

  .xl\\:p-xxl {
    padding: var(--spacing-xxl);
  }

  .xl\\:px-2xs {
    padding-left: var(--spacing-2xs);
    padding-right: var(--spacing-2xs);
  }

  .xl\\:px-base {
    padding-left: var(--spacing-base);
    padding-right: var(--spacing-base);
  }

  .xl\\:px-lg {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  .xl\\:px-xl {
    padding-left: var(--spacing-xl);
    padding-right: var(--spacing-xl);
  }

  .xl\\:px-xs {
    padding-left: var(--spacing-xs);
    padding-right: var(--spacing-xs);
  }

  .xl\\:px-xxl {
    padding-left: var(--spacing-xxl);
    padding-right: var(--spacing-xxl);
  }

  .xl\\:py-2xs {
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .xl\\:py-base {
    padding-top: var(--spacing-base);
    padding-bottom: var(--spacing-base);
  }

  .xl\\:py-lg {
    padding-top: var(--spacing-lg);
    padding-bottom: var(--spacing-lg);
  }

  .xl\\:py-xl {
    padding-top: var(--spacing-xl);
    padding-bottom: var(--spacing-xl);
  }

  .xl\\:py-xs {
    padding-top: var(--spacing-xs);
    padding-bottom: var(--spacing-xs);
  }

  .xl\\:py-xxl {
    padding-top: var(--spacing-xxl);
    padding-bottom: var(--spacing-xxl);
  }

  .xl\\:pb-2xs {
    padding-bottom: var(--spacing-2xs);
  }

  .xl\\:pb-base {
    padding-bottom: var(--spacing-base);
  }

  .xl\\:pb-lg {
    padding-bottom: var(--spacing-lg);
  }

  .xl\\:pb-xl {
    padding-bottom: var(--spacing-xl);
  }

  .xl\\:pb-xs {
    padding-bottom: var(--spacing-xs);
  }

  .xl\\:pb-xxl {
    padding-bottom: var(--spacing-xxl);
  }

  .xl\\:pl-2xs {
    padding-left: var(--spacing-2xs);
  }

  .xl\\:pl-base {
    padding-left: var(--spacing-base);
  }

  .xl\\:pl-lg {
    padding-left: var(--spacing-lg);
  }

  .xl\\:pl-xl {
    padding-left: var(--spacing-xl);
  }

  .xl\\:pl-xs {
    padding-left: var(--spacing-xs);
  }

  .xl\\:pl-xxl {
    padding-left: var(--spacing-xxl);
  }

  .xl\\:pr-2xs {
    padding-right: var(--spacing-2xs);
  }

  .xl\\:pr-base {
    padding-right: var(--spacing-base);
  }

  .xl\\:pr-lg {
    padding-right: var(--spacing-lg);
  }

  .xl\\:pr-xl {
    padding-right: var(--spacing-xl);
  }

  .xl\\:pr-xs {
    padding-right: var(--spacing-xs);
  }

  .xl\\:pr-xxl {
    padding-right: var(--spacing-xxl);
  }

  .xl\\:pt-2xs {
    padding-top: var(--spacing-2xs);
  }

  .xl\\:pt-base {
    padding-top: var(--spacing-base);
  }

  .xl\\:pt-lg {
    padding-top: var(--spacing-lg);
  }

  .xl\\:pt-xl {
    padding-top: var(--spacing-xl);
  }

  .xl\\:pt-xs {
    padding-top: var(--spacing-xs);
  }

  .xl\\:pt-xxl {
    padding-top: var(--spacing-xxl);
  }

  .xl\\:text-base {
    font-size: var(--size-text);
    line-height: var(--line-height-text);
  }

  .xl\\:text-lg {
    font-size: var(--size-text-lg);
    line-height: var(--line-height-text-lg);
  }

  .xl\\:text-sm {
    font-size: var(--size-text-sm);
    line-height: var(--line-height-text-sm);
  }

  .xl\\:text-color {
    color: var(--color-text);
  }

  .xl\\:text-color-caution {
    color: var(--color-caution);
  }

  .xl\\:text-color-critical {
    color: var(--color-critical);
  }

  .xl\\:text-color-info {
    color: var(--color-info);
  }

  .xl\\:text-color-main {
    color: var(--color-main);
  }

  .xl\\:text-color-neutral {
    color: var(--color-neutral);
  }

  .xl\\:text-color-positive {
    color: var(--color-positive);
  }

  .xl\\:text-color-semantic {
    color: var(--color-text-semantic);
  }

  .xl\\:text-color-strong {
    color: var(--color-text-strong);
  }

  .xl\\:text-color-subtle {
    color: var(--color-text-subtle);
  }
}
@media (min-width: 1536px) {

  .xxl\\:m-2xs {
    margin: var(--spacing-2xs);
  }

  .xxl\\:m-base {
    margin: var(--spacing-base);
  }

  .xxl\\:m-lg {
    margin: var(--spacing-lg);
  }

  .xxl\\:m-xl {
    margin: var(--spacing-xl);
  }

  .xxl\\:m-xs {
    margin: var(--spacing-xs);
  }

  .xxl\\:m-xxl {
    margin: var(--spacing-xxl);
  }

  .xxl\\:mx-2xs {
    margin-left: var(--spacing-2xs);
    margin-right: var(--spacing-2xs);
  }

  .xxl\\:mx-base {
    margin-left: var(--spacing-base);
    margin-right: var(--spacing-base);
  }

  .xxl\\:mx-lg {
    margin-left: var(--spacing-lg);
    margin-right: var(--spacing-lg);
  }

  .xxl\\:mx-xl {
    margin-left: var(--spacing-xl);
    margin-right: var(--spacing-xl);
  }

  .xxl\\:mx-xs {
    margin-left: var(--spacing-xs);
    margin-right: var(--spacing-xs);
  }

  .xxl\\:mx-xxl {
    margin-left: var(--spacing-xxl);
    margin-right: var(--spacing-xxl);
  }

  .xxl\\:my-2xs {
    margin-top: var(--spacing-2xs);
    margin-bottom: var(--spacing-2xs);
  }

  .xxl\\:my-base {
    margin-top: var(--spacing-base);
    margin-bottom: var(--spacing-base);
  }

  .xxl\\:my-lg {
    margin-top: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
  }

  .xxl\\:my-xl {
    margin-top: var(--spacing-xl);
    margin-bottom: var(--spacing-xl);
  }

  .xxl\\:my-xs {
    margin-top: var(--spacing-xs);
    margin-bottom: var(--spacing-xs);
  }

  .xxl\\:my-xxl {
    margin-top: var(--spacing-xxl);
    margin-bottom: var(--spacing-xxl);
  }

  .xxl\\:mb-2xs {
    margin-bottom: var(--spacing-2xs);
  }

  .xxl\\:mb-base {
    margin-bottom: var(--spacing-base);
  }

  .xxl\\:mb-lg {
    margin-bottom: var(--spacing-lg);
  }

  .xxl\\:mb-xl {
    margin-bottom: var(--spacing-xl);
  }

  .xxl\\:mb-xs {
    margin-bottom: var(--spacing-xs);
  }

  .xxl\\:mb-xxl {
    margin-bottom: var(--spacing-xxl);
  }

  .xxl\\:ml-2xs {
    margin-left: var(--spacing-2xs);
  }

  .xxl\\:ml-base {
    margin-left: var(--spacing-base);
  }

  .xxl\\:ml-lg {
    margin-left: var(--spacing-lg);
  }

  .xxl\\:ml-xl {
    margin-left: var(--spacing-xl);
  }

  .xxl\\:ml-xs {
    margin-left: var(--spacing-xs);
  }

  .xxl\\:ml-xxl {
    margin-left: var(--spacing-xxl);
  }

  .xxl\\:mr-2xs {
    margin-right: var(--spacing-2xs);
  }

  .xxl\\:mr-base {
    margin-right: var(--spacing-base);
  }

  .xxl\\:mr-lg {
    margin-right: var(--spacing-lg);
  }

  .xxl\\:mr-xl {
    margin-right: var(--spacing-xl);
  }

  .xxl\\:mr-xs {
    margin-right: var(--spacing-xs);
  }

  .xxl\\:mr-xxl {
    margin-right: var(--spacing-xxl);
  }

  .xxl\\:mt-2xs {
    margin-top: var(--spacing-2xs);
  }

  .xxl\\:mt-base {
    margin-top: var(--spacing-base);
  }

  .xxl\\:mt-lg {
    margin-top: var(--spacing-lg);
  }

  .xxl\\:mt-xl {
    margin-top: var(--spacing-xl);
  }

  .xxl\\:mt-xs {
    margin-top: var(--spacing-xs);
  }

  .xxl\\:mt-xxl {
    margin-top: var(--spacing-xxl);
  }

  .xxl\\:h-auto {
    height: auto;
  }

  .xxl\\:h-full {
    height: 100%;
  }

  .xxl\\:h-screen {
    height: 100vh;
  }

  .xxl\\:w-1\\/12 {
    width: 8.333333%;
  }

  .xxl\\:w-10\\/12 {
    width: 83.333333%;
  }

  .xxl\\:w-11\\/12 {
    width: 91.666667%;
  }

  .xxl\\:w-2\\/12 {
    width: 16.666667%;
  }

  .xxl\\:w-3\\/12 {
    width: 25%;
  }

  .xxl\\:w-4\\/12 {
    width: 33.333333%;
  }

  .xxl\\:w-5\\/12 {
    width: 41.666667%;
  }

  .xxl\\:w-6\\/12 {
    width: 50%;
  }

  .xxl\\:w-7\\/12 {
    width: 58.333333%;
  }

  .xxl\\:w-8\\/12 {
    width: 66.666667%;
  }

  .xxl\\:w-9\\/12 {
    width: 75%;
  }

  .xxl\\:w-auto {
    width: auto;
  }

  .xxl\\:w-full {
    width: 100%;
  }

  .xxl\\:w-max {
    width: max-content;
  }

  .xxl\\:w-min {
    width: min-content;
  }

  .xxl\\:w-screen {
    width: 100vw;
  }

  .xxl\\:items-start {
    align-items: flex-start;
  }

  .xxl\\:items-end {
    align-items: flex-end;
  }

  .xxl\\:items-center {
    align-items: center;
  }

  .xxl\\:items-baseline {
    align-items: baseline;
  }

  .xxl\\:items-stretch {
    align-items: stretch;
  }

  .xxl\\:justify-start {
    justify-content: flex-start;
  }

  .xxl\\:justify-end {
    justify-content: flex-end;
  }

  .xxl\\:justify-center {
    justify-content: center;
  }

  .xxl\\:justify-between {
    justify-content: space-between;
  }

  .xxl\\:justify-around {
    justify-content: space-around;
  }

  .xxl\\:justify-evenly {
    justify-content: space-evenly;
  }

  .xxl\\:space-x-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-sm > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-sm) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-sm) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-x-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xxs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .xxl\\:space-y-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
  }

  .xxl\\:space-y-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
  }

  .xxl\\:space-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
  }

  .xxl\\:space-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
  }

  .xxl\\:space-y-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
  }

  .xxl\\:space-y-xxl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxl) * var(--tw-space-y-reverse));
  }

  .xxl\\:space-y-xxs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xxs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xxs) * var(--tw-space-y-reverse));
  }

  .xxl\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-base) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-base) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xxl\\:divide-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-lg) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xxl\\:divide-x-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-md) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-md) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xxl\\:divide-x-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-none) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-none) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xxl\\:divide-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(var(--border-xl) * var(--tw-divide-x-reverse));
    border-left-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-x-reverse)));
  }

  .xxl\\:divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-base) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-base) * var(--tw-divide-y-reverse));
  }

  .xxl\\:divide-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-lg) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-lg) * var(--tw-divide-y-reverse));
  }

  .xxl\\:divide-y-md > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-md) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-md) * var(--tw-divide-y-reverse));
  }

  .xxl\\:divide-y-none > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-none) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-none) * var(--tw-divide-y-reverse));
  }

  .xxl\\:divide-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(var(--border-xl) * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(var(--border-xl) * var(--tw-divide-y-reverse));
  }

  .xxl\\:divide-current > :not([hidden]) ~ :not([hidden]) {
    border-color: currentColor;
  }

  .xxl\\:divide-transparent > :not([hidden]) ~ :not([hidden]) {
    border-color: transparent;
  }

  .xxl\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .xxl\\:rounded-full {
    border-radius: 9999px;
  }

  .xxl\\:rounded-lg {
    border-radius: var(--border-radius-lg);
  }

  .xxl\\:rounded-md {
    border-radius: var(--border-radius-md);
  }

  .xxl\\:rounded-none {
    border-radius: var(--border-radius-none);
  }

  .xxl\\:rounded-xl {
    border-radius: var(--border-radius-xl);
  }

  .xxl\\:rounded-xxl {
    border-radius: var(--border-radius-xxl);
  }

  .xxl\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .xxl\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xxl\\:rounded-b-lg {
    border-bottom-right-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .xxl\\:rounded-b-md {
    border-bottom-right-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .xxl\\:rounded-b-none {
    border-bottom-right-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .xxl\\:rounded-b-xl {
    border-bottom-right-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .xxl\\:rounded-b-xxl {
    border-bottom-right-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .xxl\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .xxl\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xxl\\:rounded-l-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-bottom-left-radius: var(--border-radius-lg);
  }

  .xxl\\:rounded-l-md {
    border-top-left-radius: var(--border-radius-md);
    border-bottom-left-radius: var(--border-radius-md);
  }

  .xxl\\:rounded-l-none {
    border-top-left-radius: var(--border-radius-none);
    border-bottom-left-radius: var(--border-radius-none);
  }

  .xxl\\:rounded-l-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-bottom-left-radius: var(--border-radius-xl);
  }

  .xxl\\:rounded-l-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-bottom-left-radius: var(--border-radius-xxl);
  }

  .xxl\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .xxl\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .xxl\\:rounded-r-lg {
    border-top-right-radius: var(--border-radius-lg);
    border-bottom-right-radius: var(--border-radius-lg);
  }

  .xxl\\:rounded-r-md {
    border-top-right-radius: var(--border-radius-md);
    border-bottom-right-radius: var(--border-radius-md);
  }

  .xxl\\:rounded-r-none {
    border-top-right-radius: var(--border-radius-none);
    border-bottom-right-radius: var(--border-radius-none);
  }

  .xxl\\:rounded-r-xl {
    border-top-right-radius: var(--border-radius-xl);
    border-bottom-right-radius: var(--border-radius-xl);
  }

  .xxl\\:rounded-r-xxl {
    border-top-right-radius: var(--border-radius-xxl);
    border-bottom-right-radius: var(--border-radius-xxl);
  }

  .xxl\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .xxl\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .xxl\\:rounded-t-lg {
    border-top-left-radius: var(--border-radius-lg);
    border-top-right-radius: var(--border-radius-lg);
  }

  .xxl\\:rounded-t-md {
    border-top-left-radius: var(--border-radius-md);
    border-top-right-radius: var(--border-radius-md);
  }

  .xxl\\:rounded-t-none {
    border-top-left-radius: var(--border-radius-none);
    border-top-right-radius: var(--border-radius-none);
  }

  .xxl\\:rounded-t-xl {
    border-top-left-radius: var(--border-radius-xl);
    border-top-right-radius: var(--border-radius-xl);
  }

  .xxl\\:rounded-t-xxl {
    border-top-left-radius: var(--border-radius-xxl);
    border-top-right-radius: var(--border-radius-xxl);
  }

  .xxl\\:border {
    border-width: var(--border-base);
  }

  .xxl\\:border-lg {
    border-width: var(--border-lg);
  }

  .xxl\\:border-md {
    border-width: var(--border-md);
  }

  .xxl\\:border-none {
    border-width: var(--border-none);
  }

  .xxl\\:border-xl {
    border-width: var(--border-xl);
  }

  .xxl\\:border-b {
    border-bottom-width: var(--border-base);
  }

  .xxl\\:border-b-lg {
    border-bottom-width: var(--border-lg);
  }

  .xxl\\:border-b-md {
    border-bottom-width: var(--border-md);
  }

  .xxl\\:border-b-none {
    border-bottom-width: var(--border-none);
  }

  .xxl\\:border-b-xl {
    border-bottom-width: var(--border-xl);
  }

  .xxl\\:border-l {
    border-left-width: var(--border-base);
  }

  .xxl\\:border-l-lg {
    border-left-width: var(--border-lg);
  }

  .xxl\\:border-l-md {
    border-left-width: var(--border-md);
  }

  .xxl\\:border-l-none {
    border-left-width: var(--border-none);
  }

  .xxl\\:border-l-xl {
    border-left-width: var(--border-xl);
  }

  .xxl\\:border-r {
    border-right-width: var(--border-base);
  }

  .xxl\\:border-r-lg {
    border-right-width: var(--border-lg);
  }

  .xxl\\:border-r-md {
    border-right-width: var(--border-md);
  }

  .xxl\\:border-r-none {
    border-right-width: var(--border-none);
  }

  .xxl\\:border-r-xl {
    border-right-width: var(--border-xl);
  }

  .xxl\\:border-t {
    border-top-width: var(--border-base);
  }

  .xxl\\:border-t-lg {
    border-top-width: var(--border-lg);
  }

  .xxl\\:border-t-md {
    border-top-width: var(--border-md);
  }

  .xxl\\:border-t-none {
    border-top-width: var(--border-none);
  }

  .xxl\\:border-t-xl {
    border-top-width: var(--border-xl);
  }

  .xxl\\:border-none {
    border-style: none;
  }

  .xxl\\:border-border {
    border-color: var(--color-border);
  }

  .xxl\\:border-caution {
    border-color: var(--color-caution);
  }

  .xxl\\:border-critical {
    border-color: var(--color-critical);
  }

  .xxl\\:border-current {
    border-color: currentColor;
  }

  .xxl\\:border-info {
    border-color: var(--color-info);
  }

  .xxl\\:border-main {
    border-color: var(--color-main);
  }

  .xxl\\:border-neutral {
    border-color: var(--color-neutral);
  }

  .xxl\\:border-positive {
    border-color: var(--color-positive);
  }

  .xxl\\:border-transparent {
    border-color: transparent;
  }

  .xxl\\:bg-background {
    background-color: var(--color-background);
  }

  .xxl\\:bg-surface {
    background-color: var(--color-surface);
  }

  .xxl\\:bg-surface-strong {
    background-color: var(--color-surface-strong);
  }

  .xxl\\:bg-surface-subtle {
    background-color: var(--color-surface-subtle);
  }

  .xxl\\:p-2xs {
    padding: var(--spacing-2xs);
  }

  .xxl\\:p-base {
    padding: var(--spacing-base);
  }

  .xxl\\:p-lg {
    padding: var(--spacing-lg);
  }

  .xxl\\:p-xl {
    padding: var(--spacing-xl);
  }

  .xxl\\:p-xs {
    padding: var(--spacing-xs);
  }

  .xxl\\:p-xxl {
    padding: var(--spacing-xxl);
  }

  .xxl\\:px-2xs {
    padding-left: var(--spacing-2xs);
    padding-right: var(--spacing-2xs);
  }

  .xxl\\:px-base {
    padding-left: var(--spacing-base);
    padding-right: var(--spacing-base);
  }

  .xxl\\:px-lg {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  .xxl\\:px-xl {
    padding-left: var(--spacing-xl);
    padding-right: var(--spacing-xl);
  }

  .xxl\\:px-xs {
    padding-left: var(--spacing-xs);
    padding-right: var(--spacing-xs);
  }

  .xxl\\:px-xxl {
    padding-left: var(--spacing-xxl);
    padding-right: var(--spacing-xxl);
  }

  .xxl\\:py-2xs {
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .xxl\\:py-base {
    padding-top: var(--spacing-base);
    padding-bottom: var(--spacing-base);
  }

  .xxl\\:py-lg {
    padding-top: var(--spacing-lg);
    padding-bottom: var(--spacing-lg);
  }

  .xxl\\:py-xl {
    padding-top: var(--spacing-xl);
    padding-bottom: var(--spacing-xl);
  }

  .xxl\\:py-xs {
    padding-top: var(--spacing-xs);
    padding-bottom: var(--spacing-xs);
  }

  .xxl\\:py-xxl {
    padding-top: var(--spacing-xxl);
    padding-bottom: var(--spacing-xxl);
  }

  .xxl\\:pb-2xs {
    padding-bottom: var(--spacing-2xs);
  }

  .xxl\\:pb-base {
    padding-bottom: var(--spacing-base);
  }

  .xxl\\:pb-lg {
    padding-bottom: var(--spacing-lg);
  }

  .xxl\\:pb-xl {
    padding-bottom: var(--spacing-xl);
  }

  .xxl\\:pb-xs {
    padding-bottom: var(--spacing-xs);
  }

  .xxl\\:pb-xxl {
    padding-bottom: var(--spacing-xxl);
  }

  .xxl\\:pl-2xs {
    padding-left: var(--spacing-2xs);
  }

  .xxl\\:pl-base {
    padding-left: var(--spacing-base);
  }

  .xxl\\:pl-lg {
    padding-left: var(--spacing-lg);
  }

  .xxl\\:pl-xl {
    padding-left: var(--spacing-xl);
  }

  .xxl\\:pl-xs {
    padding-left: var(--spacing-xs);
  }

  .xxl\\:pl-xxl {
    padding-left: var(--spacing-xxl);
  }

  .xxl\\:pr-2xs {
    padding-right: var(--spacing-2xs);
  }

  .xxl\\:pr-base {
    padding-right: var(--spacing-base);
  }

  .xxl\\:pr-lg {
    padding-right: var(--spacing-lg);
  }

  .xxl\\:pr-xl {
    padding-right: var(--spacing-xl);
  }

  .xxl\\:pr-xs {
    padding-right: var(--spacing-xs);
  }

  .xxl\\:pr-xxl {
    padding-right: var(--spacing-xxl);
  }

  .xxl\\:pt-2xs {
    padding-top: var(--spacing-2xs);
  }

  .xxl\\:pt-base {
    padding-top: var(--spacing-base);
  }

  .xxl\\:pt-lg {
    padding-top: var(--spacing-lg);
  }

  .xxl\\:pt-xl {
    padding-top: var(--spacing-xl);
  }

  .xxl\\:pt-xs {
    padding-top: var(--spacing-xs);
  }

  .xxl\\:pt-xxl {
    padding-top: var(--spacing-xxl);
  }

  .xxl\\:text-base {
    font-size: var(--size-text);
    line-height: var(--line-height-text);
  }

  .xxl\\:text-lg {
    font-size: var(--size-text-lg);
    line-height: var(--line-height-text-lg);
  }

  .xxl\\:text-sm {
    font-size: var(--size-text-sm);
    line-height: var(--line-height-text-sm);
  }

  .xxl\\:text-color {
    color: var(--color-text);
  }

  .xxl\\:text-color-caution {
    color: var(--color-caution);
  }

  .xxl\\:text-color-critical {
    color: var(--color-critical);
  }

  .xxl\\:text-color-info {
    color: var(--color-info);
  }

  .xxl\\:text-color-main {
    color: var(--color-main);
  }

  .xxl\\:text-color-neutral {
    color: var(--color-neutral);
  }

  .xxl\\:text-color-positive {
    color: var(--color-positive);
  }

  .xxl\\:text-color-semantic {
    color: var(--color-text-semantic);
  }

  .xxl\\:text-color-strong {
    color: var(--color-text-strong);
  }

  .xxl\\:text-color-subtle {
    color: var(--color-text-subtle);
  }

  .\\32xl\\:w-1\\/12 {
    width: 8.333333%;
  }

  .\\32xl\\:w-10\\/12 {
    width: 83.333333%;
  }

  .\\32xl\\:w-11\\/12 {
    width: 91.666667%;
  }

  .\\32xl\\:w-2\\/12 {
    width: 16.666667%;
  }

  .\\32xl\\:w-3\\/12 {
    width: 25%;
  }

  .\\32xl\\:w-4\\/12 {
    width: 33.333333%;
  }

  .\\32xl\\:w-5\\/12 {
    width: 41.666667%;
  }

  .\\32xl\\:w-6\\/12 {
    width: 50%;
  }

  .\\32xl\\:w-7\\/12 {
    width: 58.333333%;
  }

  .\\32xl\\:w-8\\/12 {
    width: 66.666667%;
  }

  .\\32xl\\:w-9\\/12 {
    width: 75%;
  }

  .\\32xl\\:items-start {
    align-items: flex-start;
  }

  .\\32xl\\:items-end {
    align-items: flex-end;
  }

  .\\32xl\\:items-center {
    align-items: center;
  }

  .\\32xl\\:items-baseline {
    align-items: baseline;
  }

  .\\32xl\\:items-stretch {
    align-items: stretch;
  }

  .\\32xl\\:justify-start {
    justify-content: flex-start;
  }

  .\\32xl\\:justify-end {
    justify-content: flex-end;
  }

  .\\32xl\\:justify-center {
    justify-content: center;
  }

  .\\32xl\\:justify-between {
    justify-content: space-between;
  }

  .\\32xl\\:justify-around {
    justify-content: space-around;
  }

  .\\32xl\\:justify-evenly {
    justify-content: space-evenly;
  }

  .\\32xl\\:space-x-2xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-x-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-2xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-x-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-base) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-base) * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-x-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-lg) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-lg) * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-x-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xl) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xl) * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-x-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(var(--spacing-xs) * var(--tw-space-x-reverse));
    margin-left: calc(var(--spacing-xs) * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-y-2xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xl) * var(--tw-space-y-reverse));
  }

  .\\32xl\\:space-y-2xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-2xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-2xs) * var(--tw-space-y-reverse));
  }

  .\\32xl\\:space-y-base > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-base) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-base) * var(--tw-space-y-reverse));
  }

  .\\32xl\\:space-y-lg > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-lg) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-lg) * var(--tw-space-y-reverse));
  }

  .\\32xl\\:space-y-xl > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xl) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xl) * var(--tw-space-y-reverse));
  }

  .\\32xl\\:space-y-xs > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(var(--spacing-xs) * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(var(--spacing-xs) * var(--tw-space-y-reverse));
  }

  .\\32xl\\:rounded-2xl {
    border-radius: 1rem;
  }

  .\\32xl\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .\\32xl\\:rounded-full {
    border-radius: 9999px;
  }

  .\\32xl\\:rounded-lg {
    border-radius: var(--border-radius-lg);
  }

  .\\32xl\\:rounded-md {
    border-radius: var(--border-radius-md);
  }

  .\\32xl\\:rounded-none {
    border-radius: var(--border-radius-none);
  }

  .\\32xl\\:rounded-xl {
    border-radius: var(--border-radius-xl);
  }

  .\\32xl\\:border {
    border-width: var(--border-base);
  }

  .\\32xl\\:border-lg {
    border-width: var(--border-lg);
  }

  .\\32xl\\:border-md {
    border-width: var(--border-md);
  }

  .\\32xl\\:border-none {
    border-width: var(--border-none);
  }

  .\\32xl\\:border-xl {
    border-width: var(--border-xl);
  }

  .\\32xl\\:border-b {
    border-bottom-width: var(--border-base);
  }

  .\\32xl\\:border-b-lg {
    border-bottom-width: var(--border-lg);
  }

  .\\32xl\\:border-b-md {
    border-bottom-width: var(--border-md);
  }

  .\\32xl\\:border-b-none {
    border-bottom-width: var(--border-none);
  }

  .\\32xl\\:border-b-xl {
    border-bottom-width: var(--border-xl);
  }

  .\\32xl\\:border-l {
    border-left-width: var(--border-base);
  }

  .\\32xl\\:border-l-lg {
    border-left-width: var(--border-lg);
  }

  .\\32xl\\:border-l-md {
    border-left-width: var(--border-md);
  }

  .\\32xl\\:border-l-none {
    border-left-width: var(--border-none);
  }

  .\\32xl\\:border-l-xl {
    border-left-width: var(--border-xl);
  }

  .\\32xl\\:border-r {
    border-right-width: var(--border-base);
  }

  .\\32xl\\:border-r-lg {
    border-right-width: var(--border-lg);
  }

  .\\32xl\\:border-r-md {
    border-right-width: var(--border-md);
  }

  .\\32xl\\:border-r-none {
    border-right-width: var(--border-none);
  }

  .\\32xl\\:border-r-xl {
    border-right-width: var(--border-xl);
  }

  .\\32xl\\:border-t {
    border-top-width: var(--border-base);
  }

  .\\32xl\\:border-t-lg {
    border-top-width: var(--border-lg);
  }

  .\\32xl\\:border-t-md {
    border-top-width: var(--border-md);
  }

  .\\32xl\\:border-t-none {
    border-top-width: var(--border-none);
  }

  .\\32xl\\:border-t-xl {
    border-top-width: var(--border-xl);
  }

  .\\32xl\\:border-none {
    border-style: none;
  }

  .\\32xl\\:border-border {
    border-color: var(--color-border);
  }

  .\\32xl\\:border-caution {
    border-color: var(--color-caution);
  }

  .\\32xl\\:border-critical {
    border-color: var(--color-critical);
  }

  .\\32xl\\:border-current {
    border-color: currentColor;
  }

  .\\32xl\\:border-info {
    border-color: var(--color-info);
  }

  .\\32xl\\:border-main {
    border-color: var(--color-main);
  }

  .\\32xl\\:border-neutral {
    border-color: var(--color-neutral);
  }

  .\\32xl\\:border-positive {
    border-color: var(--color-positive);
  }

  .\\32xl\\:border-transparent {
    border-color: transparent;
  }

  .\\32xl\\:bg-background {
    background-color: var(--color-background);
  }

  .\\32xl\\:bg-surface {
    background-color: var(--color-surface);
  }

  .\\32xl\\:bg-surface-strong {
    background-color: var(--color-surface-strong);
  }

  .\\32xl\\:bg-surface-subtle {
    background-color: var(--color-surface-subtle);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd,qBAAA;AAAc;;AAAd;EAAA,cAAc;EAAd,UAAA;AAAc;;AAAd;EAAA,UAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd,mBAAA;AAAc;;AAAd;EAAA,oBAAA;AAAc;;AAAd;EAAA,cAAc;EAAd,iBAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd,yBAAA;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,yBAAA;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,sBAAA;AAAc;;AAAd;EAAA,kBAAA;AAAc;;AAAd;EAAA,mBAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAA;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAA;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,gBAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA,gBAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd,8BAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA,gBAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd,8BAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd,oBAAA;AAAc;;AAAd;EAAA,6BAAc;EAAd,0CAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;AACd;EAAA,WAAA;AAAoB;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,UAAoB;EAApB,yBAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,6BAAoB;EAApB,iBAAoB;EAApB,cAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,sBAAA;AAAoB;AAApB;EAAA,kBAAA;AAAoB;AAApB;EAAA,mBAAA;AAAoB;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAA;AAAoB;AAApB;EAAA,yBAAoB;EAApB,8BAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,4BAAA;AAAoB;AAApB;EAAA,yDAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;EAAA,yDAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,8BAAA;AAAoB;AAApB;EAAA,yDAAoB;EAApB,yBAAoB;EAApB,8BAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,4BAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,8BAAA;AAAoB;AAApB;EAAA,2BAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,2BAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAA;AAAoB;AAApB;EAAA,4BAAoB;EAApB,0BAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,4BAAA;AAAoB;AAApB;EAAA,wBAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,+BAAA;AAAoB;AAApB;EAAA,8BAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,gCAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,0BAAoB;EAApB,gDAAoB;EAApB,oCAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,iBAAA;AAAoB;AAApB;EAAA,mBAAA;AAAoB;AAApB;EAAA,oBAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB,sBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,cAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,sBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,cAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,cAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,cAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;EAApB,4GAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,wBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,YAAA;AAAoB;AAApB;EAAA,YAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,cAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,wCAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,yBAAA;AAAoB;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,UAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB,oBAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB,sBAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,+CAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,sBAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,yBAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,+CAAA;AAAoB;AAApB;EAAA,sBAAA;AAAoB;AAApB;EAAA,wBAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,4CAAA;AAAoB;AAApB;EAAA,mBAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAA;AAAoB;AAApB;EAAA,kCAAoB;EAApB,6CAAoB;EAApB,yCAAoB;EAApB,mCAAoB;EAApB,yCAAoB;EAApB,yCAAoB;EAApB,wCAAoB;EAApB,kCAAoB;EAApB,uCAAoB;EAApB,mDAAoB;EAApB,6CAAoB;EAApB,uBAAoB;EAApB,gCAAoB;EAApB,kCAAoB;EAApB,4CAAoB;EAApB,8CAAoB;EAApB,0CAAoB;EAApB,0CAAoB;EAApB,+BAAoB;EAApB,gCAAoB;EAApB,+BAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,kCAAoB;EAApB,6BAAoB;EAApB,iCAAoB;EAApB,wCAAoB;EAApB,mCAAoB;EAApB,2BAAoB;EAApB,0CAAoB;EAApB,4BAAoB;EAApB,mCAAoB;EAApB,0CAAoB;EAApB,qCAAoB;EAApB,qCAAoB;EAApB,eAAoB;EAApB,iBAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB,gBAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB,oBAAA;AAAoB;AAApB;EAAA,qBAAA;AAAoB;AAApB;EAAA,qBAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,kBAAA;AAAoB;AAApB;EAAA,qBAAA;AAAoB;AAApB;EAAA,kBAAA;AAAoB;AAApB;EAAA,qBAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,eAAA;AAAoB;AAApB;EAAA,gBAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,yBAAA;AAAoB;AAApB;EAAA,eAAA;AAAoB;AAApB;EAAA,gBAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB,kBAAA;AAAoB;AAApB;EAAA,aAAA;AAAoB;AAApB;EAAA,gBAAA;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB,eAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB,UAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,WAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,+LAAA;AAAmB;AAAnB;EAAA,oMAAA;AAAmB;AAAnB;;EAAA;IAAA,WAAA;EAAmB;AAAA;AAAnB;EAAA,yDAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB,iEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,gEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,kEAAmB;EAAnB,2EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,kEAAmB;EAAnB,2EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mEAAmB;EAAnB,4EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,iEAAmB;EAAnB,0EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,iEAAmB;EAAnB,0EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,iEAAmB;EAAnB,0EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,iEAAmB;EAAnB,0EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,kEAAmB;EAAnB,2EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,kEAAmB;EAAnB,2EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,0EAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB,qDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2EAAmB;EAAnB,oEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,yEAAmB;EAAnB,kEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,yEAAmB;EAAnB,kEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,yEAAmB;EAAnB,kEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,yEAAmB;EAAnB,kEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,0EAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,0EAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,yEAAmB;EAAnB,kFAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,uEAAmB;EAAnB,gFAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,uEAAmB;EAAnB,gFAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,yEAAmB;EAAnB,kFAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,uEAAmB;EAAnB,gFAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,iFAAmB;EAAnB,0EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,+EAAmB;EAAnB,wEAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,+EAAmB;EAAnB,wEAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,iFAAmB;EAAnB,0EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,+EAAmB;EAAnB,wEAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,yCAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mDAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,qDAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,qDAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,oCAAA;AAAmB;AAAnB;EAAA,oCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,oCAAA;AAAmB;AAAnB;EAAA,oCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,oCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,yCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,+CAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,yCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,6CAAA;AAAmB;AAAnB;EAAA,6CAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,oEAAA;AAAmB;AAAnB;EAAA,qEAAA;AAAmB;AAAnB;EAAA,mEAAA;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,qEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,kFAAmB;EAAnB,qEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,qEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,qEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,qEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,mCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,cAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,cAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,oCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,uCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,uCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,uCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0CAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,0CAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iLAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iLAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,iLAAA;AAAmB;AAAnB;EAAA,iLAAA;AAAmB;AAAnB;EAAA,uQAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;;AAGnB;;EAEE,UAAU;EACV,SAAS;EACT;wEACsE;EACtE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,4CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,wCAAwC;AAEtC;;;;;;;;;;;;;IAaE,cAAc;EAChB;AAEA;;;;;;IAME,iBAAiB;IACjB,mBAAmB;EACrB;AAEA;;IAEE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;AA3FF;EAAA,6CAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,yCAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,gCAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,4CAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,4CAAA;AAAA;AAAA;EAAA,6CAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,4CAAA;AAAA;AAAA;EAAA,2CAAA;AAAA;AAAA;EAAA,4CAAA;AAAA;AAAA;EAAA,+BAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,wCAAA;AAAA;AAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,uDAAA;IAAA,gEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,mEAAA;IAAA,4EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2DAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2EAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,qDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,oDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,kDAAA;IAAA,qDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,iDAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,iCAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,cAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,eAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,mEAAA;IAAA,4EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2EAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,qDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,oDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,kDAAA;IAAA,qDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,iDAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,oBAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,iCAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,iBAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,mEAAA;IAAA,4EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2EAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,qDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,oDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,kDAAA;IAAA,qDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,iDAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kBAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,iCAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,mBAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,mEAAA;IAAA,4EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2EAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,qDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,oDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,kDAAA;IAAA,qDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,iDAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,6BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,aAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,WAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,YAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,mEAAA;IAAA,4EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2EAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,yEAAA;IAAA,kFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,uEAAA;IAAA,gFAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,iFAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,wBAAA;IAAA,+EAAA;IAAA,wEAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,qDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,mDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,oDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,kDAAA;IAAA,qDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,mDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,oDAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,iDAAA;IAAA,kDAAA;EAAA;;EAAA;IAAA,+CAAA;IAAA,gDAAA;EAAA;;EAAA;IAAA,gDAAA;IAAA,iDAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,2BAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,8BAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,wBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,4BAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,gBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,iBAAA;EAAA;;EAAA;IAAA,UAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,oBAAA;EAAA;;EAAA;IAAA,2BAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,uBAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,6BAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,kEAAA;IAAA,2EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,mEAAA;IAAA,4EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,iEAAA;IAAA,0EAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,0EAAA;IAAA,mEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,2EAAA;IAAA,oEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,uBAAA;IAAA,yEAAA;IAAA,kEAAA;EAAA;;EAAA;IAAA,mBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,qBAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,wCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,gCAAA;EAAA;;EAAA;IAAA,8BAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,uCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,qCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,oCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,kBAAA;EAAA;;EAAA;IAAA,iCAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,0BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,+BAAA;EAAA;;EAAA;IAAA,kCAAA;EAAA;;EAAA;IAAA,mCAAA;EAAA;;EAAA;IAAA,yBAAA;EAAA;;EAAA;IAAA,yCAAA;EAAA;;EAAA;IAAA,sCAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;;EAAA;IAAA,6CAAA;EAAA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import \"./colors-light.css\";\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n  background-color: white;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.g327 {\n  border-color: #302f30;\n}\n\n@font-face {\n  font-family: 'AvenirNextW10-Bold';\n  src: url('../public/fonts/AvenirNext.ttf');\n}\n\n.Avenir {\n  font-family: AvenirNextW10-Bold;\n  font-display: swap;\n}\n\n.clearNav {\n  backdrop-filter: saturate(180%) blur(5px) !important;\n  background-color: rgba(255, 255, 255, 0.6) !important;\n}\n\n.grr {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.greyC {\n  filter: gray;\n  -webkit-filter: grayscale(100%);\n  transition: 0.4s;\n}\n\n.greyC:hover {\n  filter: none;\n  -webkit-filter: none;\n  transition: 0.4s;\n}\n\n/* Revert Tailwind CSS reset/preflight */\n.tailwind-reset-revert {\n  blockquote,\n  dl,\n  dd,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  hr,\n  figure,\n  p,\n  pre {\n    margin: revert;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: revert;\n    font-weight: revert;\n  }\n\n  ol,\n  ul {\n    list-style: revert;\n    margin: revert;\n    padding: revert;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
